// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T19:01:15.279Z
// Property: Redwood Ypsilanti Apartments (ID: 6767906449167447)
// Collections: 55 amenities, 7 floorplans (live), 43 photos, 85 POIs, 16 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449167447",
  "property_external_id": "q41x27w",
  "property_zillow_url": "https://www.zillow.com/apartments/ypsilanti-mi/redwood-ypsilanti/Ch7FRB/",
  "property_apartments_url": "https://www.apartments.com/redwood-ypsilanti-ypsilanti-mi/q41x27w/",
  "property_google_business_url": "https://www.google.com/maps/place/Redwood+Ypsilanti/data=!4m2!3m1!1s0x0:0x9ef153820f879a7f?sa=X&ved=2ahUKEwi3kOrn55eUAxXjkIkEHYliKgYQ_BJ6BAhSEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "redwood-ypsilanti-apartments",
  "property_name": "Redwood Ypsilanti Apartments",
  "property_website_url": "https://rentatredwood.com/apartments/mi/ypsilanti/redwood-ypsilanti/contact/",
  "property_domain": null,
  "property_address": "9226 White Wing Dr",
  "property_full_address": "9226 White Wing Dr, Ypsilanti, MI 48197",
  "property_address_1": "9226 White Wing Dr",
  "property_address_2": null,
  "property_address_city": "Ypsilanti",
  "property_address_state": "MI",
  "property_address_zip_full": null,
  "property_address_zip": "48197",
  "property_address_country": "US",
  "property_address_county": "Washtenaw County",
  "property_neighborhood_address": "Ypsilanti",
  "property_address_latitude": "42.195863",
  "property_address_longitude": "-83.5798386",
  "property_email": null,
  "property_phone": "(734) 398-3631",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Redwood Ypsilanti Apartments, where modern living meets comfort. Our spacious two-bedroom layouts feature granite countertops, energy-efficient appliances, and serene private patios. Enjoy 24/7 on-site maintenance, community events, and beautiful green spaces just 35 minutes from downtown Detroit. Your perfect home awaits—explore our availability today!",
  "property_long_description": "Welcome to Redwood Ypsilanti Apartments, the perfect blend of convenience and comfort, located just 35 minutes from downtown Detroit. Our thoughtfully designed two-bedroom floor plans feature spacious layouts, en-suite bathrooms, and large closets, ensuring both privacy and relaxation. Enjoy modern living with our energy-efficient appliances, including dishwashers and microwaves, complemented by stunning granite countertops and stainless steel finishes. Each apartment also boasts a private entrance and a cozy patio with sliding glass doors, perfect for enjoying your tranquil surroundings.\n\nOur community is designed to enhance your lifestyle with on-site management, 24/7 maintenance, and professional landscaping that includes beautifully maintained green spaces and walking trails. You'll appreciate the curbside trash pickup and recycling services, as well as having an attached two-car garage included with your rent. With flexible den spaces and full-size washer/dryer hookups, you can truly make your apartment feel like home.\n\nAt Redwood Ypsilanti, we foster a welcoming atmosphere with resident events throughout the year and ample guest parking. We’re also pet-friendly, allowing up to three pets per home, so your furry friends can enjoy the community as well. Experience the perfect balance of nature and convenience with our peaceful neighborhood layout, highlighted by a picturesque water feature and many walking paths.\n\nDon't miss out on the opportunity to call Redwood Ypsilanti your new home. Browse our availability or schedule a self-guided tour today to experience firsthand what makes our community special!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
    "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
    "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
    "width": 2880,
    "height": 2160
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "142",
  "property_year_built": "2018",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.59154929577466",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "40",
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Restricted dog breeds: Akita, Chow, Doberman Pinscher, Pitbull, Rottweiler, Shar‑Pei, Staffordshire Terrier, or any mixed breeds that include those listed.",
  "property_pet_policy_description": "We allow up to three pets per home (cats and dogs). One-time non-refundable pet fee: $300 per home. Monthly pet rent: $40 per home. No weight restrictions. Restricted dog breeds: Akita, Chow, Doberman Pinscher, Pitbull, Rottweiler, Shar‑Pei, Staffordshire Terrier, or any mixed breeds that include those listed.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-65f7-70ad-ad89-dbf351fbaad8.webp",
  "property_primary_logo_media": {
    "alt_text": "Redwood Apartment Neighborhoods logo",
    "public_id": "019d752f-65f7-70ad-ad89-dbf351fbaad8",
    "storage_key": "property/6767906449167447/019d752f-65f7-70ad-ad89-dbf351fbaad8.webp",
    "width": 366,
    "height": 70
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-b852-714d-a7a8-d6200d062014.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019d752f-b852-714d-a7a8-d6200d062014",
    "storage_key": "property/6767906449167447/019d752f-b852-714d-a7a8-d6200d062014.webp",
    "width": 366,
    "height": 70
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-ac64-70fb-85d2-0b0cb6365087.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d752f-ac64-70fb-85d2-0b0cb6365087",
    "storage_key": "property/6767906449167447/019d752f-ac64-70fb-85d2-0b0cb6365087.webp",
    "width": 366,
    "height": 70
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#f00000",
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": null,
  "property_bathrooms_range": "2",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": null,
  "property_sqft_range": "1,294 - 1,851 sq ft",
  "property_sqft_min": "1,294",
  "property_sqft_max": "1,851",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/Redwood-Living-821766174564157/",
  "property_instagram_url": "https://www.instagram.com/byredwood",
  "property_twitter_url": "https://twitter.com/byRedwood",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJl0_qwhJYO4gRf5qHD4JT8Z4",
  "property_youtube_url": "https://www.youtube.com/user/redwoodlivingtv",
  "property_yelp_url": "https://www.yelp.com/biz/nautica-pointe-by-redwood-ypsilanti",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Redwood Ypsilanti Apartments",
  "property_home_romance_title": "Embrace Serenity and Connection in Your New Apartment Home  ",
  "property_home_amenities_blurb": "Welcome to Redwood Ypsilanti Apartments, where comfort meets modern living. Enjoy spacious two-bedroom layouts, featuring energy-efficient appliances, stunning granite countertops, and a private patio. With 24/7 maintenance and scenic walking trails, your new home awaits just 35 minutes from downtown Detroit, offering the perfect blend of convenience and tranquility.",
  "property_home_floorplans_blurb": "Welcome to Redwood Ypsilanti Apartments, where modern living meets comfort in the heart of Ypsilanti, MI. Our thoughtfully designed floor plans cater to every lifestyle, offering spacious layouts and contemporary finishes. Browse our available apartment homes today and discover the ideal space for your next chapter.",
  "property_home_gallery_blurb": "At Redwood Ypsilanti Apartments, enjoy modern living with spacious two-bedroom layouts and elegant finishes. Embrace the outdoors with scenic walking and biking trails, while our dedicated team ensures comfort with 24/7 maintenance. Picture your life here, surrounded by lush green spaces and unmatched convenience just 35 minutes from downtown Detroit!",
  "property_home_neighborhood_blurb": "Welcome to Redwood Ypsilanti Apartments, where cozy two-bedroom living meets a vibrant neighborhood. Enjoy easy access to Eastern Michigan University, local parks, and exciting attractions like the Michigan Flight Museum and Rolling Hills Water Park. Discover your new lifestyle while enjoying the best of Ypsilanti just outside your door!",
  "property_home_reviews_blurb": "At Redwood Ypsilanti Apartments, residents cherish the vibrant community and unparalleled comfort. One happy tenant raves, “The spacious layouts and friendly atmosphere make this place feel like home.” Come see what our residents have to say about living at our welcoming community in Ypsilanti, MI—your ideal rental oasis awaits!",
  "property_neighborhood_blurb": "Welcome to Redwood Ypsilanti Apartments, where vibrant community living meets rich opportunities. Unwind at scenic parks, engage with the local culture at the Michigan Flight Museum, or catch a game at Rynearson Stadium—all just moments away. Immerse yourself in Ypsilanti's unique charm and see what awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Experience comfort at Redwood Ypsilanti Apartments, where modern living meets serene landscapes. Enjoy spacious two-bedroom layouts with designer kitchens, energy-efficient appliances, and private patios. With 24/7 on-site maintenance and scenic walking trails, every detail is crafted for your convenience. Embrace a vibrant lifestyle just 35 minutes from downtown Detroit!",
  "property_applynow_blurb": "At Redwood Ypsilanti Apartments, your vibrant lifestyle awaits! Choose from spacious two-bedroom layouts featuring modern amenities like a fully equipped kitchen with granite countertops, en-suite bathrooms, and access to beautiful green spaces. Enjoy 24/7 on-site maintenance, pet-friendly policies, and walking trails—all just 35 minutes from downtown Detroit. Find your new home and lease online today!",
  "property_contactus_blurb": "At Redwood Ypsilanti Apartments, spacious two-bedroom floor plans await to suit your lifestyle. Nestled in vibrant Ypsilanti, MI, our community offers modern amenities and a welcoming atmosphere. Have questions? Our friendly leasing team is here to help—reach out today to find your perfect home!",
  "property_faqs_blurb": "At Redwood Ypsilanti Apartments, our spacious two-bedroom floor plans are designed for comfortable living in charming Ypsilanti, MI. Curious about our community? Browse our FAQs page for insights and answers to help you envision your new home with us. Your ideal apartment experience awaits!",
  "property_floorplans_blurb": "At Redwood Ypsilanti Apartments, our two-bedroom floor plans offer the perfect blend of comfort and style in Ypsilanti, MI. With versatile layouts and inviting spaces, each home is designed to fit your lifestyle. Browse our available options and find the ideal space to call your own today!",
  "property_gallery_blurb": "At Redwood Ypsilanti Apartments, your lifestyle unfolds amidst beautifully landscaped green spaces and tranquil walking trails. Enjoy modern living with spacious two-bedroom floor plans, energy-efficient appliances, and a welcoming community vibe. Picture yourself relaxing on your private patio or connecting with neighbors at resident events—your perfect home awaits!",
  "property_interactivemap_blurb": "Nestled in the heart of Ypsilanti, Redwood Ypsilanti Apartments offers spacious two-bedroom homes with luxurious amenities like granite countertops and energy-efficient appliances. Enjoy serene green spaces, convenient on-site maintenance, and quick access to downtown Detroit. Connect with our vibrant community using our interactive map to find your ideal apartment today!",
  "property_pets_blurb": "At Redwood Ypsilanti Apartments, your furry friends are part of the family! With no weight limits and space for up to three pets, you'll enjoy pet-friendly living in a vibrant community. Nestled in Ypsilanti, MI, your home is perfect for both you and your companions.",
  "property_referafriend_blurb": "At Redwood Ypsilanti Apartments, our spacious two-bedroom floor plans offer the perfect blend of comfort and style. Nestled in vibrant Ypsilanti, MI, our welcoming community thrives on friendship. Share the love—refer a friend today and enjoy the perks of great neighbors and a fantastic living experience!",
  "property_residentaccess_blurb": "Welcome to Redwood Ypsilanti Apartments, where your two-bedroom oasis awaits in vibrant Ypsilanti, MI. Seamlessly manage your living experience through our resident portal—pay rent, schedule maintenance, and connect with your community effortlessly. Dive into comfort and convenience today!",
  "property_reviews_blurb": "At Redwood Ypsilanti Apartments, our residents love the vibrant community atmosphere and spacious living. One satisfied tenant shared, \"The friendly staff and beautiful surroundings make this place feel like home.\" Curious about their experiences? Dive into our resident reviews and see what makes our community truly special!",
  "property_created_at": "1775787490932",
  "property_scheduletour_blurb": "At Redwood Ypsilanti Apartments, spacious two-bedroom floor plans offer comfort and style in the heart of Ypsilanti, MI. Embrace a vibrant community and explore unique living spaces tailored for your needs. Curious about what makes life here special? Hear directly from our residents and schedule your tour today!",
  "property_thankyou_blurb": "Thank you for your interest in Redwood Ypsilanti Apartments! Nestled in vibrant Ypsilanti, MI, our spacious two-bedroom floor plans offer a perfect blend of comfort and style. Keep an eye on your inbox—our team will reach out shortly to assist you in finding your ideal home!",
  "property_virtualtours_blurb": "Step into the inviting charm of Redwood Ypsilanti Apartments, where spacious two-bedroom layouts blend comfort and style. Nestled in Ypsilanti, MI, our community offers a unique living experience. Take a virtual tour today and envision your future home filled with warmth and modern amenities!",
  "property_copyright": "2026 All Rights Reserved. Redwood Ypsilanti Apartments",
  "property_seo_title_home": "Redwood Ypsilanti Apartments |  Apartments in Ypsilanti, MI",
  "property_seo_description_home": "Discover Redwood Ypsilanti Apartments: modern two-bedroom homes, beautiful green spaces, and top-notch amenities. Secure your haven today!",
  "property_seo_title_floorplans": "Floor Plans | Ypsilanti, MI Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal two-bedroom layout at Redwood Ypsilanti Apartments. Browse our unique floor plans in vibrant Ypsilanti, MI, and start your next chapter today!",
  "property_seo_title_amenities": "Amenities | Ypsilanti, MI Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Redwood Ypsilanti Apartments! Enjoy spacious layouts, 24/7 maintenance, and lush green spaces—your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Ypsilanti, MI",
  "property_seo_description_gallery": "Discover Redwood Ypsilanti Apartments: spacious two-bedroom layouts, lush greenery, and 24/7 maintenance, only 35 minutes from downtown Detroit!",
  "property_seo_title_virtualtours": "Virtual Tours | Redwood Ypsilanti Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Redwood Ypsilanti Apartments! Take a virtual tour of our spacious two-bedroom homes and vibrant community in Ypsilanti, MI today!",
  "property_seo_title_interactivemap": "Interactive Map | Redwood Ypsilanti Apartments Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Redwood Ypsilanti Apartments. Enjoy spacious two-bedroom layouts with top-notch amenities and scenic walking trails. Check our map now!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ypsilanti, MI",
  "property_seo_description_neighborhood": "Discover Ypsilanti from Redwood Apartments. Enjoy local spots, parks, and dining steps from your future home. Embrace community life!",
  "property_seo_title_contact": "Contact Us | Redwood Ypsilanti Apartments",
  "property_seo_description_contact": "Reach out to Redwood Ypsilanti Apartments! Explore our two-bedroom floor plans in Ypsilanti, MI. Your new home awaits—contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Ypsilanti, MI",
  "property_seo_description_faqs": "Discover Redwood Ypsilanti Apartments! Our FAQs cover amenities and floor plans for a vibrant living experience in Ypsilanti, MI.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ypsilanti, MI",
  "property_seo_description_reviews": "Join our Ypsilanti community! Discover spacious floor plans, great amenities, and a welcoming atmosphere. Your new home awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Ypsilanti, MI",
  "property_seo_description_applynow": "Discover modern living at Redwood Ypsilanti! Spacious two-bedroom apartments with great amenities, only 35 mins from downtown Detroit. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Redwood Ypsilanti Apartments",
  "property_seo_description_residentaccess": "Unlock convenience at Redwood Ypsilanti Apartments! Log in to your resident portal to pay rent, request maintenance, and manage your home effortlessly.",
  "property_seo_title_referafriend": "Refer A Friend | Redwood Ypsilanti Apartments",
  "property_seo_description_referafriend": "Bring your friends home to Redwood Ypsilanti Apartments! Refer a friend and enjoy great neighbors, vibrant living, and a thriving community in Ypsilanti, MI.",
  "property_seo_title_scheduletour": "Schedule a Tour | Redwood Ypsilanti Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Redwood Ypsilanti Apartments. Schedule a tour today and find your perfect home in the heart of Ypsilanti, MI!",
  "property_seo_title_privacy": "Privacy Policy | Redwood Ypsilanti Apartments",
  "property_seo_description_privacy": "Safeguarding your information is our priority. Review the Redwood Ypsilanti Apartments Privacy Policy to understand how we protect your privacy.",
  "property_seo_title_accessibility": "Website Accessibility | Redwood Ypsilanti Apartments",
  "property_seo_description_accessibility": "Redwood Ypsilanti Apartments embraces digital inclusion with a welcoming community focused on accessibility. Your comfort is our commitment!",
  "property_seo_title_sitemap": "Sitemap | Redwood Ypsilanti Apartments",
  "property_seo_description_sitemap": "Navigate your way to your ideal home at Redwood Ypsilanti Apartments. Check out our sitemap for a seamless journey through our vibrant community!",
  "property_seo_title_thankyou": "Thank You | Redwood Ypsilanti Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Redwood Ypsilanti Apartments begins now. Stay tuned for updates from our friendly team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Ypsilanti, MI",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1777628954127",
  "amenities": [
    {
      "id": "ec_5b89fe7a9529a25fed7a113a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "24 Hour Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84f0758f25dee928b8106e09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dba4b75db185d54368076693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Furnished Units Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90b9689f2e1be1ac8babc740",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_405be78b1df3b064146f8360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Trash Pickup - Curbside",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d978b7f6fa3c3211f78970a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4517572f8d01151e22428659",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Walking/Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f39cb8acbd5d857dc7d2ef17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "24/7 maintenance handled by our on-site team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a256b378b5f2e095e80844f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "35 minutes from downtown Detroit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_299698bca2a1d754d6e45afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Attached two-car garage included with rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92bef31e52988f99a3e5df52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Beautiful green spaces throughout",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca7a79f8e10190d113aadbee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f88b5ad429dffc8f8955e364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Designated guest parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7880925d66977bd5a650f6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher & microwave included",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d98b51fdcbcc434d1767df0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Energy efficient appliances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bb7d11ff3042c4788b7f0f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "En-suite bathroom & large closet in main bedroom",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_85071ec26cc092a398ba2576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Flexible den space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18c4eee6fc0cd50aedd87d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Full-size washer/dryer hookups",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a8fcb8178b090a1898f17061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite countertops & stainless steel appliances",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9d4f05e04f15be65e43fa51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "High-quality carpet in bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2c0bfa9fd672e46d580c4a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Large kitchen with a full pantry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52c0c275f468b76159cd6c6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "No smoking allowed in homes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c34d896b2ee40cce752da8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Plank flooring in main rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28b144dd171f817a0d07f947",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Private front entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dbb26f25c77105687147957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Professional landscaping & snow removal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b224092f0a5045d5e24d366",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Resident events throughout the year",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_732e0ccccb9e2217288246d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Self-Guided Tours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a08edf9f58924f6e1182cfa1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Single-story and two-story floor plans",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de3e5146759f2363635451d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Sliding glass doors to personal patios",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47812b5efc0da9ce399e4142",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Spacious second bedroom with large closet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a7d145e918f57d897c70750",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Two full bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fed29e9f3250183c56ab4012",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Up to three pets allowed per home",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_425cb5c844e1a7ed41ef5b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Walking path throughout the neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_feacd11cba665ac8b2689cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Washers & dryers available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24030bc4a26499da22e47f07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Water feature in the neighborhood",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9304f2c8ed8bd2af0b4139e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Welcoming neighborhood layout",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_354a80f52f84fed24011acbf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e84ca02902be96f240cacc5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a73e35b4d758ead219d16f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ca60c494ba0d89c970abf48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2386cf6c6ce7c7b150f5e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6744d19e599294999fb48834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96119368712a35b72b02c734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff0f92cb9843d4391559c68f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_616f3d817716bb1eb5f576a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d54914f279712e36674e2adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9996cbe105a35d793248e84c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96442e0e230083f279d1e480",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fc0f29583a3852598d74430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0074cd602cf84662f4e9c800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac8f00e95977d97d65102dc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbaf195e6db878d61790e44a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e2242eda43565d49fc262ede",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Den",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d144df4e9c06782f5a2ab33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc87407ebd14698ea1a1819e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_4fd664c39da1db6840b1dd42",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-e044-7155-a865-03503eaac2a8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a clear blue sky.",
        "public_id": "019da442-e044-7155-a865-03503eaac2a8",
        "storage_key": "property/6767906449167447/019da442-e044-7155-a865-03503eaac2a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment exteriors featuring spacious garages and well-maintained landscaping, offering a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6555u9vj6hlLaTz-KdBYLrUqSANxp9AuMInuDzqx5fc/102/image.jpg"
    },
    {
      "id": "ec_aaf8079aa233ad56985b7a04",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-e044-7155-a865-03503eaac2a8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a clear blue sky.",
        "public_id": "019da442-e044-7155-a865-03503eaac2a8",
        "storage_key": "property/6767906449167447/019da442-e044-7155-a865-03503eaac2a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment exteriors featuring spacious garages and well-maintained landscaping, offering a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6555u9vj6hlLaTz-KdBYLrUqSANxp9AuMInuDzqx5fc/102/image.jpg"
    },
    {
      "id": "ec_90b9c2921cf28517ce1f50f9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-777e-75db-adcb-4daef5b53fae.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a sofa, coffee table, TV, and kitchen island.",
        "public_id": "019d752f-777e-75db-adcb-4daef5b53fae",
        "storage_key": "property/6767906449167447/019d752f-777e-75db-adcb-4daef5b53fae.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Spacious living room and kitchen featuring a comfortable sofa, modern TV, and a fully equipped kitchen island with bar stools.",
      "link": "false",
      "alt_text": "Living room and kitchen area with a sofa, coffee table, TV, and kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/mosY9r1iIXz5vereciQ11EGdbnrrtsRjYEj95oXPTFs/102/image.jpg"
    },
    {
      "id": "ec_d2718beb266c28276f5388c4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-04af-7005-a798-77fb86f73c93.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with island seating, sofa, TV, and view into bedroom.",
        "public_id": "019da443-04af-7005-a798-77fb86f73c93",
        "storage_key": "property/6767906449167447/019da443-04af-7005-a798-77fb86f73c93.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area and kitchen featuring an island with seating, a comfortable sofa, a large TV, and a glimpse into a well-appointed bedroom.",
      "link": "false",
      "alt_text": "Open concept living and kitchen area with island seating, sofa, TV, and view into bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KK-qHoHpgzCQQXsYlgSQ3Y3CMPoRfF9ahhOA4y_G7kE/102/image.jpg"
    },
    {
      "id": "ec_a0de44ca04f598d2e2327c14",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-063b-70ca-810f-f5af196da56a.webp",
      "image_media": {
        "alt_text": "Walk-in pantry with wire shelving stocked with food items.",
        "public_id": "019da443-063b-70ca-810f-f5af196da56a",
        "storage_key": "property/6767906449167447/019da443-063b-70ca-810f-f5af196da56a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in pantry featuring ample wire shelving, perfect for organizing your groceries and dry goods.",
      "link": "false",
      "alt_text": "Walk-in pantry with wire shelving stocked with food items.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/RPzKybb4QRJMp4iwVDnk0iDGqXZ_M9QgPj2oihDObVQ/119/image.jpg"
    },
    {
      "id": "ec_bc6a962fbba97b62433f0091",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-06fb-71d9-90bb-ccd24beec434.webp",
      "image_media": {
        "alt_text": "Modern living room with open-concept kitchen and balcony access.",
        "public_id": "019da443-06fb-71d9-90bb-ccd24beec434",
        "storage_key": "property/6767906449167447/019da443-06fb-71d9-90bb-ccd24beec434.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area with a comfortable sofa, coffee table, and a sleek kitchen. Enjoy natural light and access to a private balcony.",
      "link": "false",
      "alt_text": "Modern living room with open-concept kitchen and balcony access.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/vyvNJqRTCicPtqV9LU0zbM6L5_qelc1rtuNiZeAsCTA/102/image.jpg"
    },
    {
      "id": "ec_73bb1d95689f942053372686",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-e88a-745d-a237-9d55fda4218a.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table, overlooking a wooded area.",
        "public_id": "019da442-e88a-745d-a237-9d55fda4218a",
        "storage_key": "property/6767906449167447/019da442-e88a-745d-a237-9d55fda4218a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, complete with seating and a table, offering a peaceful view of the surrounding nature.",
      "link": "false",
      "alt_text": "Balcony with two chairs and a table, overlooking a wooded area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hOxYeA1rF4LJfcTiq2StMYlmtEH1MlkbWC9OdaBbing/119/image.jpg"
    },
    {
      "id": "ec_bd94ab516cb49e682b3651c6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-dd37-72ac-97c0-0df8e94645b5.webp",
      "image_media": {
        "alt_text": "Covered balcony with wicker furniture and sliding glass door.",
        "public_id": "019da442-dd37-72ac-97c0-0df8e94645b5",
        "storage_key": "property/6767906449167447/019da442-dd37-72ac-97c0-0df8e94645b5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private, covered balcony, complete with outdoor seating. A perfect extension of your living space.",
      "link": "false",
      "alt_text": "Covered balcony with wicker furniture and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KZTbrSN_8Iw2EV4pItjIkDuXKXAB-ASpeyOhX_4ijqU/102/image.jpg"
    },
    {
      "id": "ec_5dfadf93b483733d29af2051",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-010c-77ce-9fe3-d372fb87f66a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island with seating.",
        "public_id": "019da443-010c-77ce-9fe3-d372fb87f66a",
        "storage_key": "property/6767906449167447/019da443-010c-77ce-9fe3-d372fb87f66a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a granite-topped island perfect for casual dining or entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/9sejXcFgITfg3jhcMbsl13Tj7lbRI0S13ksyxXXyZ7M/118/image.jpg"
    },
    {
      "id": "ec_c5f151c19fc294bf6414658e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-088b-77cd-9189-859e7fc14da5.webp",
      "image_media": {
        "alt_text": "Modern living room with grey sofa, coffee table, and open kitchen with wood cabinets.",
        "public_id": "019da443-088b-77cd-9189-859e7fc14da5",
        "storage_key": "property/6767906449167447/019da443-088b-77cd-9189-859e7fc14da5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush grey sofa and a sleek coffee table, seamlessly flowing into a modern kitchen with rich wood cabinetry.",
      "link": "false",
      "alt_text": "Modern living room with grey sofa, coffee table, and open kitchen with wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/P9miToQOdXMK_8eIDTx5YzzAEQBK9aCMsHH_Dcvc2nI/102/image.jpg"
    },
    {
      "id": "ec_7a15f703867b693d4b9447b8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-268d-747d-924a-22017a15395a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment.",
        "public_id": "019da443-268d-747d-924a-22017a15395a",
        "storage_key": "property/6767906449167447/019da443-268d-747d-924a-22017a15395a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room with a comfortable sofa and coffee table, adjacent to a modern kitchen with stainless steel appliances.",
      "link": "false",
      "alt_text": "Living room and kitchen area of an apartment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/37KGXzQpM42AGm2SdKHEswGLdQQGAx2QSy1KGITlBhs/119/image.jpg"
    },
    {
      "id": "ec_d11a2c9baaddffab91630f24",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-294d-746f-84b7-96d391cc54d0.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of an apartment with a sectional sofa, coffee table, and kitchen island with bar stools.",
        "public_id": "019da443-294d-746f-84b7-96d391cc54d0",
        "storage_key": "property/6767906449167447/019da443-294d-746f-84b7-96d391cc54d0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living and kitchen area featuring a comfortable sectional sofa, a sleek coffee table, and a modern kitchen island with bar stools, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen of an apartment with a sectional sofa, coffee table, and kitchen island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/F_AtlCSQmJtfDmJLS5Ow-5BXi0l3ZgVLOt2FPUJT3FA/102/image.jpg"
    },
    {
      "id": "ec_6dd68ce05f1ea0a1430de501",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-2940-7129-9af7-d18d13f0012f.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round table, four chairs, and wall art displaying floor plans.",
        "public_id": "019da443-2940-7129-9af7-d18d13f0012f",
        "storage_key": "property/6767906449167447/019da443-2940-7129-9af7-d18d13f0012f.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Floorplan",
      "description": "Discover the layouts of our diverse floor plans, showcasing the modern finishes and spacious designs available at our community.",
      "link": "false",
      "alt_text": "Modern dining area with a round table, four chairs, and wall art displaying floor plans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Dq8mRZkROzSSbIvZMu1B6q1srQ534n10G3prqYafxM4/119/image.jpg"
    },
    {
      "id": "ec_78f6b9a119c6e527df7e0842",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-3861-764e-bd82-d733ed79cb80.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a ceiling fan.",
        "public_id": "019da443-3861-764e-bd82-d733ed79cb80",
        "storage_key": "property/6767906449167447/019da443-3861-764e-bd82-d733ed79cb80.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant nightstands with lamps, and a ceiling fan for added comfort. The room includes a view into the en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bM0pTDm_zHdwqqiRJTulRs4N-_Brb6OMzEohk4YW4lo/102/image.jpg"
    },
    {
      "id": "ec_33dc97503af3cc19a4be696f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-3c2a-748f-91d6-f805cc548cca.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops, wood cabinets, and a shower/tub combo.",
        "public_id": "019da443-3c2a-748f-91d6-f805cc548cca",
        "storage_key": "property/6767906449167447/019da443-3c2a-748f-91d6-f805cc548cca.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a spacious bathroom featuring a double vanity with granite countertops, ample cabinet storage, and a convenient shower/tub combination.",
      "link": "false",
      "alt_text": "Double vanity bathroom with granite countertops, wood cabinets, and a shower/tub combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/HGLA0SzJcbeD_7-3caduPu-gQzQGFgNV-979yTul90o/118/image.jpg"
    },
    {
      "id": "ec_39b3fa20d24d3e9e212c9dfb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-5380-768e-9061-e137d93d48a8.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, ceiling fan, and large window.",
        "public_id": "019da443-5380-768e-9061-e137d93d48a8",
        "storage_key": "property/6767906449167447/019da443-5380-768e-9061-e137d93d48a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring plush carpeting, elegant decor, and ample natural light.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-sized bed, ceiling fan, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/1EehKepHc_bFpxVX-yUM5kk01Sd-GCd-pWNfpi1AQiw/102/image.jpg"
    },
    {
      "id": "ec_7ad3ecb6f32ce1678db1cb25",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-4383-711c-88d9-c6582dad4593.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub and shower, and separate laundry area with washer and dryer.",
        "public_id": "019da443-4383-711c-88d9-c6582dad4593",
        "storage_key": "property/6767906449167447/019da443-4383-711c-88d9-c6582dad4593.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This apartment features a bathroom with a bathtub and shower, as well as a convenient in-unit laundry area with a washer and dryer.",
      "link": "false",
      "alt_text": "Bathroom with bathtub and shower, and separate laundry area with washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/0_30iD9pfX5TgaoraNWJuxIe1izUlYfihrC27n1o710/119/image.jpg"
    },
    {
      "id": "ec_e57a83435e8bf50be919d024",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-5188-70db-bf39-8b5d4e194692.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with overhead cabinets.",
        "public_id": "019da443-5188-70db-bf39-8b5d4e194692",
        "storage_key": "property/6767906449167447/019da443-5188-70db-bf39-8b5d4e194692.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer with ample storage space in the overhead cabinets, making laundry day a breeze.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with overhead cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/7bS8ncxnrtsHcg9sbqlioowU6xFoGDRJjsEwB3aUemA/102/image.jpg"
    },
    {
      "id": "ec_2df3c38df88ed0f314d902d0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-513b-7061-bf3c-75a0a2137b67.webp",
      "image_media": {
        "alt_text": "Aerial view of townhomes with garages, surrounded by manicured lawns and trees.",
        "public_id": "019da443-513b-7061-bf3c-75a0a2137b67",
        "storage_key": "property/6767906449167447/019da443-513b-7061-bf3c-75a0a2137b67.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Charming townhomes with attached garages, set amidst lush green lawns and mature trees, offering a picturesque community setting.",
      "link": "false",
      "alt_text": "Aerial view of townhomes with garages, surrounded by manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Cl5mY5wz_dvZFwXrFhN7Zn-DHnHAE6xlmDZo2eOV6y4/118/image.jpg"
    },
    {
      "id": "ec_e9065393f0c5167ef2601587",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-dd2a-7152-b92f-1267839311e8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a blue sky.",
        "public_id": "019da442-dd2a-7152-b92f-1267839311e8",
        "storage_key": "property/6767906449167447/019da442-dd2a-7152-b92f-1267839311e8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover comfortable living in these apartment buildings featuring attached garages and spacious, green lawns.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with garages and manicured lawns under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/WbcLUXqIs6CeA2JiikhPeYZRm0r7Bo7cQf7RQlduG-4/102/image.jpg"
    },
    {
      "id": "ec_7735b33274f7143d96828e6f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-5509-76c8-b8cc-936f7b712603.webp",
      "image_media": {
        "alt_text": "Spacious two-car garage with white walls, gray epoxy flooring, and a large garage door.",
        "public_id": "019da443-5509-76c8-b8cc-936f7b712603",
        "storage_key": "property/6767906449167447/019da443-5509-76c8-b8cc-936f7b712603.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy ample storage space in this private two-car garage, featuring a clean epoxy floor and convenient access.",
      "link": "false",
      "alt_text": "Spacious two-car garage with white walls, gray epoxy flooring, and a large garage door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/I95N3NHXE608xlFjjtTBH2PbT9UdL1p2kh6v1pnMCZI/118/image.jpg"
    },
    {
      "id": "ec_587f0a631126dff8129f38b9",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-5c86-75e0-8e9d-d4cd2df9b070.webp",
      "image_media": {
        "alt_text": "Aerial view of townhomes and surrounding landscape with a pond and trees in autumn.",
        "public_id": "019da443-5c86-75e0-8e9d-d4cd2df9b070",
        "storage_key": "property/6767906449167447/019da443-5c86-75e0-8e9d-d4cd2df9b070.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Beautiful aerial view showcasing the townhomes and the scenic surroundings, including a serene pond and vibrant autumn foliage. Enjoy the peaceful community atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of townhomes and surrounding landscape with a pond and trees in autumn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OamaMQFlQrDBSFQEcMpZFYvkmc5fhiBNSOF5kACzy2Y/102/image.jpg"
    },
    {
      "id": "ec_a3bd7bd9ffa72509a0efaeec",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-6f71-76ec-b98a-713449f3a5a6.webp",
      "image_media": {
        "alt_text": "Redwood Apartment Neighborhoods sign and entrance on a sunny day.",
        "public_id": "019da443-6f71-76ec-b98a-713449f3a5a6",
        "storage_key": "property/6767906449167447/019da443-6f71-76ec-b98a-713449f3a5a6.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Welcome to Redwood Apartment Neighborhoods, featuring a scenic entrance with a monument sign and well-maintained grounds.",
      "link": "false",
      "alt_text": "Redwood Apartment Neighborhoods sign and entrance on a sunny day.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_2dJi4BjSyE7ogUAyZiw8Sw3qGtJDvEqeUNF6A-KtVo/118/image.jpg"
    },
    {
      "id": "ec_6bd90408190311d965527cb1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-721f-7225-a5e8-fb8baee7a43f.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with single-family homes and apartment buildings.",
        "public_id": "019da443-721f-7225-a5e8-fb8baee7a43f",
        "storage_key": "property/6767906449167447/019da443-721f-7225-a5e8-fb8baee7a43f.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Drone footage showcasing a well-maintained residential community with diverse housing options, lush greenery, and a serene pond.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with single-family homes and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/dX711HnIbbVKeHfeycLuQ6zxL9JSOntIoLr5NnDMxCk/102/image.jpg"
    },
    {
      "id": "ec_d12b8e36f5898b0d5def6a6f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-74d0-7195-a85a-bead1380385a.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential community with a pond and fountains.",
        "public_id": "019da443-74d0-7195-a85a-bead1380385a",
        "storage_key": "property/6767906449167447/019da443-74d0-7195-a85a-bead1380385a.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Experience serene living with our beautiful pond and fountains, offering a picturesque view of the community.",
      "link": "false",
      "alt_text": "Aerial view of a residential community with a pond and fountains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/J5tfkAbhFAPUZOiDME9gF316Pmnpyf3cvWts0Ht0sjE/118/image.jpg"
    },
    {
      "id": "ec_5978c2c8d3792511f6aeb72f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da443-78fd-71ab-9ea6-1511d275f716.webp",
      "image_media": {
        "alt_text": "Exterior view of townhome buildings with green lawn and blue sky.",
        "public_id": "019da443-78fd-71ab-9ea6-1511d275f716",
        "storage_key": "property/6767906449167447/019da443-78fd-71ab-9ea6-1511d275f716.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience comfortable living in these townhomes, featuring private back decks and well-maintained exteriors surrounded by lush greenery.",
      "link": "false",
      "alt_text": "Exterior view of townhome buildings with green lawn and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/54DDxN_H81LoNMjMBJTMvyr56vd5jkMcVR2RZeAZN0U/102/image.jpg"
    },
    {
      "id": "ec_1496418b2ef9496c9b80b2e2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-ab3f-7272-9d3a-840a7fa74875.webp",
      "image_media": {
        "alt_text": "Living room with a staircase, sliding glass doors, and a large window.",
        "public_id": "019d752f-ab3f-7272-9d3a-840a7fa74875",
        "storage_key": "property/6767906449167447/019d752f-ab3f-7272-9d3a-840a7fa74875.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a contemporary ceiling fan, a staircase leading to an upper level, sliding glass doors, and a large window for natural light.",
      "link": "false",
      "alt_text": "Living room with a staircase, sliding glass doors, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FJyQlHkovteNlSmUwnTTbBzWO8dCdCA7wDK32CVS1HM/119/image.jpg"
    },
    {
      "id": "ec_155acac257ae9e5b196f7f5c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-b251-7038-b7a3-8dcf5e1f5137.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, coffee table, and an open kitchen area.",
        "public_id": "019d752f-b251-7038-b7a3-8dcf5e1f5137",
        "storage_key": "property/6767906449167447/019d752f-b251-7038-b7a3-8dcf5e1f5137.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living area with comfortable seating and a modern open-concept kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room with a gray sofa, coffee table, and an open kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/bIQ3ZYMP6ufmZrfrP6sn3sP91LeWMtEzqS1LcB0PhHk/102/image.jpg"
    },
    {
      "id": "ec_50406d9eccd0a3e63692885d",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-b1d3-7109-ac4b-3efa302a7f1c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
        "public_id": "019d752f-b1d3-7109-ac4b-3efa302a7f1c",
        "storage_key": "property/6767906449167447/019d752f-b1d3-7109-ac4b-3efa302a7f1c.webp",
        "width": 2047,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover this stylish kitchen, perfect for entertaining, featuring a spacious island with seating, sleek cabinetry, and top-of-the-line stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and island seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tkcb9C1OsqcTBRmCAjUugT5kGCORTQKiXkIKA1QoM_4/119/image.jpg"
    },
    {
      "id": "ec_9a30689ec35855b9c7431392",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-ba01-75af-bfd2-5ffa6cf23ea4.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and TV.",
        "public_id": "019d752f-ba01-75af-bfd2-5ffa6cf23ea4",
        "storage_key": "property/6767906449167447/019d752f-ba01-75af-bfd2-5ffa6cf23ea4.webp",
        "width": 2047,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sofa, a sleek coffee table, and an entertainment center with a television.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/2Sbswd7B60CL64Bas1V3y7fNsxr1gSmzMKmRRwYsekY/102/image.jpg"
    },
    {
      "id": "ec_0830916e814c77468ac870d1",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-c03d-75fc-aaa5-761e9146d21d.webp",
      "image_media": {
        "alt_text": "Living room with grey sectional sofa, glass coffee table, and entertainment center with TV.",
        "public_id": "019d752f-c03d-75fc-aaa5-761e9146d21d",
        "storage_key": "property/6767906449167447/019d752f-c03d-75fc-aaa5-761e9146d21d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in the spacious living area, perfect for entertaining or unwinding after a long day.",
      "link": "false",
      "alt_text": "Living room with grey sectional sofa, glass coffee table, and entertainment center with TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TTI_fIPsZychtPG4fGlml5TuNOXsxO2R2mHdhFFZXMA/119/image.jpg"
    },
    {
      "id": "ec_4c0e63521915f8597c09d228",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-c038-727b-b346-90288ad8efff.webp",
      "image_media": {
        "alt_text": "Dining area with round table and chairs, adjacent to kitchen and living room.",
        "public_id": "019d752f-c038-727b-b346-90288ad8efff",
        "storage_key": "property/6767906449167447/019d752f-c038-727b-b346-90288ad8efff.webp",
        "width": 2047,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy a meal in this spacious dining area, perfect for entertaining. The open-concept layout flows seamlessly into the kitchen and living room, offering a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "Dining area with round table and chairs, adjacent to kitchen and living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/L_n-LTpGCPREw3YnT_uWcuAsyKkpaL0aQt2hGy26TEU/102/image.jpg"
    },
    {
      "id": "ec_7dfa743f18788ec915480f57",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-d31b-71f6-b439-86dc27fa99dc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a breakfast bar with seating.",
        "public_id": "019d752f-d31b-71f6-b439-86dc27fa99dc",
        "storage_key": "property/6767906449167447/019d752f-d31b-71f6-b439-86dc27fa99dc.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and a spacious breakfast bar perfect for casual dining or entertaining guests.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a breakfast bar with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BM1rYD74N54CtZKN9944Ky23xfSlr7twCIj4TNJtuII/119/image.jpg"
    },
    {
      "id": "ec_80077d6d25a41e0242f1d6c6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-c867-7340-9c81-79aabb1381c0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with seating.",
        "public_id": "019d752f-c867-7340-9c81-79aabb1381c0",
        "storage_key": "property/6767906449167447/019d752f-c867-7340-9c81-79aabb1381c0.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and a functional island perfect for casual dining or entertaining guests.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and an island with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/faSTCH_UEMjUTMMXL8xqbOh2i_cU-bBIZByxqy_8rGQ/102/image.jpg"
    },
    {
      "id": "ec_7bb9303823ffa59d9dc03d91",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-cf34-777b-bf69-ea72e3f9f878.webp",
      "image_media": {
        "alt_text": "Open concept living and kitchen area with island seating and a TV.",
        "public_id": "019d752f-cf34-777b-bf69-ea72e3f9f878",
        "storage_key": "property/6767906449167447/019d752f-cf34-777b-bf69-ea72e3f9f878.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and kitchen area featuring a large island with seating, perfect for entertaining and everyday dining.",
      "link": "false",
      "alt_text": "Open concept living and kitchen area with island seating and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U1Bq8LCnX-UYKlNB_2EqpFLsmdlpggwfMlHQP7NpTKE/117/image.jpg"
    },
    {
      "id": "ec_9120e0250f6964313fd407b5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-d71d-716f-a7bb-bedf8100ae91.webp",
      "image_media": {
        "alt_text": "Patio with two chairs and a coffee table, overlooking the kitchen.",
        "public_id": "019d752f-d71d-716f-a7bb-bedf8100ae91",
        "storage_key": "property/6767906449167447/019d752f-d71d-716f-a7bb-bedf8100ae91.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee on the private patio, accessible from the living area and overlooking the kitchen.",
      "link": "false",
      "alt_text": "Patio with two chairs and a coffee table, overlooking the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rTNcLXHwjyrf1Q7HE58gqDEnTlJe8C_20Kd64GydG2Y/102/image.jpg"
    },
    {
      "id": "ec_92ba3461f72d3fdeec62cbee",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-ebf9-72c0-91c7-7be44144e870.webp",
      "image_media": {
        "alt_text": "Washer and dryer in laundry room with wooden cabinets and framed art.",
        "public_id": "019d752f-ebf9-72c0-91c7-7be44144e870",
        "storage_key": "property/6767906449167447/019d752f-ebf9-72c0-91c7-7be44144e870.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, with ample storage space in the overhead cabinets.",
      "link": "false",
      "alt_text": "Washer and dryer in laundry room with wooden cabinets and framed art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/NC6Y2KYkcTo5TZZnO0No-rhVZKPce71fBp063UJqF8U/116/image.jpg"
    },
    {
      "id": "ec_1b8f0b9debc0fcdcbd59276c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7530-0967-726d-a4ef-ac88cf08811e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with siding and stone accents.",
        "public_id": "019d7530-0967-726d-a4ef-ac88cf08811e",
        "storage_key": "property/6767906449167447/019d7530-0967-726d-a4ef-ac88cf08811e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming apartment exterior featuring welcoming entrances and manicured landscaping, offering a comfortable living experience.",
      "link": "false",
      "alt_text": "Exterior view of apartment building entrance with siding and stone accents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/c3u2fnUTm1Yk9snHFl91T3Z0JIZ_nSfPh3nus2nEFjc/116/image.jpg"
    },
    {
      "id": "ec_0f08f5f3bfab3109714921b3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7530-29b4-71e1-acbc-a565aa5e5eaa.webp",
      "image_media": {
        "alt_text": "Row of townhomes with garages under a clear blue sky.",
        "public_id": "019d7530-29b4-71e1-acbc-a565aa5e5eaa",
        "storage_key": "property/6767906449167447/019d7530-29b4-71e1-acbc-a565aa5e5eaa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Townhome exteriors featuring attached garages, neatly landscaped yards, and a bright blue sky.",
      "link": "false",
      "alt_text": "Row of townhomes with garages under a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8ZgrFv9xwwmx-Cy1fkEK86sqzaUlxvvTAeUPlDsOIKQ/115/image.jpg"
    },
    {
      "id": "ec_063b76f0eb84c499affc5eb0",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7530-1cfb-7451-b11c-0d5406434559.webp",
      "image_media": {
        "alt_text": "Aerial view of a serene pond and apartment buildings in a suburban setting.",
        "public_id": "019d7530-1cfb-7451-b11c-0d5406434559",
        "storage_key": "property/6767906449167447/019d7530-1cfb-7451-b11c-0d5406434559.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience tranquility with our beautiful pond, offering a peaceful retreat amidst modern apartment living.",
      "link": "false",
      "alt_text": "Aerial view of a serene pond and apartment buildings in a suburban setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/hcG-xPb4eS2-ryKdQ3v78_sjWBMjY5p08RVZ1xTQ3xs/116/image.jpg"
    },
    {
      "id": "ec_03b04119300c000dea7856c2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7530-21e1-7006-910e-1b7a1eab470a.webp",
      "image_media": {
        "alt_text": "Redwood Apartment Neighborhoods monument sign with landscaping.",
        "public_id": "019d7530-21e1-7006-910e-1b7a1eab470a",
        "storage_key": "property/6767906449167447/019d7530-21e1-7006-910e-1b7a1eab470a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Redwood Apartment Neighborhoods, a beautiful community with lush landscaping and modern signage.",
      "link": "false",
      "alt_text": "Redwood Apartment Neighborhoods monument sign with landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/OXgCibIL0sUQpFiCq0Pc9RRlauNoNWiksZcRlkyhS48/115/image.jpg"
    },
    {
      "id": "ec_e9ef1fda0253471a051db444",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019da442-e160-7322-a651-2f2674c4a842.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with townhouses and a pond with fountains.",
        "public_id": "019da442-e160-7322-a651-2f2674c4a842",
        "storage_key": "property/6767906449167447/019da442-e160-7322-a651-2f2674c4a842.webp",
        "width": 2048,
        "height": 1536
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing a modern suburban community featuring townhouses, manicured lawns, and a serene pond with elegant fountains.",
      "link": "false",
      "alt_text": "Aerial view of a suburban neighborhood with townhouses and a pond with fountains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/fLKIybpV3A-8fMiwyiGDsZHsK7pZUAkFXmQU3Lsla4E/116/image.jpg"
    },
    {
      "id": "ec_943bc472308122544b2e09a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7530-28e6-70d7-9aba-8410fd5930da.webp",
      "image_media": {
        "alt_text": "Living room and dining area of an apartment with furniture and decor.",
        "public_id": "019d7530-28e6-70d7-9aba-8410fd5930da",
        "storage_key": "property/6767906449167447/019d7530-28e6-70d7-9aba-8410fd5930da.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living and dining area, perfect for relaxing or entertaining guests.",
      "link": "false",
      "alt_text": "Living room and dining area of an apartment with furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/sCP3_SfiUEFSr8hc_71uGa3w3pIBfrWIpNxMcKlb1W0/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_84c7a7c451afd1a8458d4c16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Bellflower",
      "poi_type": "Restaurants",
      "poi_address": "209 Pearl St # 202, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Contemporary spot with a patio offering a seasonal, locally sourced dinner menu & cocktails.",
      "poi_long_description": "Contemporary spot with a patio offering a seasonal, locally sourced dinner menu & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cb05-71bb-a4f1-5895024f63c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a restaurant with a bar and kitchen area, featuring modern lighting and seating.",
        "public_id": "019d7532-cb05-71bb-a4f1-5895024f63c0",
        "storage_key": "property/6767906449167447/019d7532-cb05-71bb-a4f1-5895024f63c0.webp",
        "width": 828,
        "height": 1026
      },
      "poi_business_url": "http://bellflowerypsi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16173080487133772176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellflower",
      "poi_latitude": "42.2420887",
      "poi_longitude": "-83.61528899999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRUgbIcmpPIgRkPlorwNTcuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_e8b35f5e34a418dd96608af4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Sidetrack Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "56 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Lively railroad-themed bar with deck serves handmade burgers & local beer amid taxidermied trophies.",
      "poi_long_description": "Lively railroad-themed bar with deck serves handmade burgers & local beer amid taxidermied trophies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-d776-77dd-9ea4-5210028885d3.webp",
      "poi_featured_image_media": {
        "alt_text": "The Sidetrack building exterior with a prominent sign and red door.",
        "public_id": "019d752e-d776-77dd-9ea4-5210028885d3",
        "storage_key": "property/6767906449167447/019d752e-d776-77dd-9ea4-5210028885d3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.sidetrackbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11541650875217029556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sidetrack-bar-and-grill",
      "poi_latitude": "42.245798",
      "poi_longitude": "-83.60896699999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-483-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7r7ni-oPIgRtCnjGlIuLKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_2f91b475ae7aee2d24240094",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Aubree's Pizzeria & Grill",
      "poi_type": "Restaurants",
      "poi_address": "39 E Cross St #1972, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Laid-back pizza joint serving pies & burgers with unique toppings, plus a full bar with local brews.",
      "poi_long_description": "Laid-back pizza joint serving pies & burgers with unique toppings, plus a full bar with local brews.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cf85-7766-9b24-715f212c0c85.webp",
      "poi_featured_image_media": {
        "alt_text": "Aubrees Pizzeria & Grill storefront with red brick building exterior and a dark pickup truck parked out front.",
        "public_id": "019d7532-cf85-7766-9b24-715f212c0c85",
        "storage_key": "property/6767906449167447/019d7532-cf85-7766-9b24-715f212c0c85.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.aubrees.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=258545475603928485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aubrees-pizzeria--grill",
      "poi_latitude": "42.2461668",
      "poi_longitude": "-83.6095465",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-483-1870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-SWaXTeoPIgRpRWof72JlgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_b7e072629e96598a906ddfe9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "MAÍZ Mexican Cantina",
      "poi_type": "Restaurants",
      "poi_address": "36 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "From-scratch Mexican classics, including fajitas & enchiladas, at a casual eatery with a full bar.",
      "poi_long_description": "From-scratch Mexican classics, including fajitas & enchiladas, at a casual eatery with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-d830-766e-8b5d-9aba768a7dce.webp",
      "poi_featured_image_media": {
        "alt_text": "Maiz Mexican Cantina sign on a brick building with yellow accents",
        "public_id": "019d752e-d830-766e-8b5d-9aba768a7dce",
        "storage_key": "property/6767906449167447/019d752e-d830-766e-8b5d-9aba768a7dce.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://maizmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10206892855069531294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maz-mexican-cantina",
      "poi_latitude": "42.24574339999999",
      "poi_longitude": "-83.6097612",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-340-6010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxV8rtuoPIgRnlzkJvkqpo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_a59c6279de14e79ab7f039c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Hyperion Coffee Co",
      "poi_type": "Restaurants",
      "poi_address": "306D N River St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Casual coffee joint, also selling beans, featuring baked goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cb96-77a0-a93a-1d92bfdd6893.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Hyperion Coffee Co. building with brick facade, green doors and windows, and a large banner.",
        "public_id": "019d7532-cb96-77a0-a93a-1d92bfdd6893",
        "storage_key": "property/6767906449167447/019d7532-cb96-77a0-a93a-1d92bfdd6893.webp",
        "width": 1080,
        "height": 719
      },
      "poi_business_url": "http://www.hyperioncoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1686137209886000816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyperion-coffee-co",
      "poi_latitude": "42.2447517",
      "poi_longitude": "-83.6083594",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-547-5329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b0c-731d-af41-ae2d64c12dd9.webp",
      "poi_map_icon_media": {
        "alt_text": "Coffee cup icon",
        "public_id": "019d7534-0b0c-731d-af41-ae2d64c12dd9",
        "storage_key": "property/6767906449167447/019d7534-0b0c-731d-af41-ae2d64c12dd9.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJWZJfHDqoPIgRsMbS3dtcZhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_5138e84184822a3a2e38a49e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Arbor Brewing Company - Corner Brewery",
      "poi_type": "Restaurants",
      "poi_address": "720 Norris St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Casual pub at Arbor Brewing Company's distribution hub offers counter service for pints & pub grub.",
      "poi_long_description": "Casual pub at Arbor Brewing Company's distribution hub offers counter service for pints & pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-cdd1-724c-8fa4-ec0c23a83dab.webp",
      "poi_featured_image_media": {
        "alt_text": "Corner Brewery building exterior signage.",
        "public_id": "019d752e-cdd1-724c-8fa4-ec0c23a83dab",
        "storage_key": "property/6767906449167447/019d752e-cdd1-724c-8fa4-ec0c23a83dab.webp",
        "width": 800,
        "height": 536
      },
      "poi_business_url": "http://www.arborbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2929851001627387768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arbor-brewing-company---corner-brewery",
      "poi_latitude": "42.25031600000001",
      "poi_longitude": "-83.609956",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-480-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgdpSmzaoPIgReKfShPbrqCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "ec_8489d2fe4e726adbe30664f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Bomber Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "306 E Michigan Ave, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Mom-&-pop brunch diner adorned with model airplanes famous for an enormous breakfast platter.",
      "poi_long_description": "Mom-&-pop brunch diner adorned with model airplanes famous for an enormous breakfast platter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cfe8-728d-8980-762150c5cfd5.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a restaurant with model airplanes hanging from the ceiling and walls decorated with memorabilia.",
        "public_id": "019d7532-cfe8-728d-8980-762150c5cfd5",
        "storage_key": "property/6767906449167447/019d7532-cfe8-728d-8980-762150c5cfd5.webp",
        "width": 3072,
        "height": 2144
      },
      "poi_business_url": "http://www.bomberrestaurant.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1829306287619309680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bomber-restaurant",
      "poi_latitude": "42.2409026",
      "poi_longitude": "-83.60591629999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-482-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtcpfgzuoPIgRcADwYmAAYxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_4f0a7600bdeb6c4d519f9fda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Tap Room",
      "poi_type": "Restaurants",
      "poi_address": "201 W Michigan Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Chill, brick-lined spot with a patio offering pub grub & beer, plus pool, shuffleboard & live music.",
      "poi_long_description": "Chill, brick-lined spot with a patio offering pub grub & beer, plus pool, shuffleboard & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-db3f-75ae-9ea1-410c6423b74b.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the \"Tap Room\" building with a prominent neon sign and street view.",
        "public_id": "019d7532-db3f-75ae-9ea1-410c6423b74b",
        "storage_key": "property/6767906449167447/019d7532-db3f-75ae-9ea1-410c6423b74b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.taproomypsi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8466388796369907328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tap-room",
      "poi_latitude": "42.2408144",
      "poi_longitude": "-83.61475469999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-482-5320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQ_otECoPIgRgK754cCnfnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_140de7567b3d3c2785229cdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Got Burger!",
      "poi_type": "Restaurants",
      "poi_address": "301 W Cross St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Burger shop offering a choice of patties & toppings in a simple space with a few outdoor tables.",
      "poi_long_description": "Burger shop offering a choice of patties & toppings in a simple space with a few outdoor tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cd8f-72e6-92d9-abfccab22062.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a red building with a black base, signage, and a window display.",
        "public_id": "019d7532-cd8f-72e6-92d9-abfccab22062",
        "storage_key": "property/6767906449167447/019d7532-cd8f-72e6-92d9-abfccab22062.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.gotburgerrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16477356317454429567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "got-burger",
      "poi_latitude": "42.24560049999999",
      "poi_longitude": "-83.6164076",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-219-7240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC66RLEaoPIgRf-1oG0VUq-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_c09fd614549b2a43b6997a01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "STUFD",
      "poi_type": "Restaurants",
      "poi_address": "505 W Cross St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Big burritos & other Mexican staples offered in a simple space with a foosball table.",
      "poi_long_description": "Big burritos & other Mexican staples offered in a simple space with a foosball table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cac5-70e6-b7a2-58a2e1d94611.webp",
      "poi_featured_image_media": {
        "alt_text": "Building exterior with red door and windows during snowfall.",
        "public_id": "019d7532-cac5-70e6-b7a2-58a2e1d94611",
        "storage_key": "property/6767906449167447/019d7532-cac5-70e6-b7a2-58a2e1d94611.webp",
        "width": 2048,
        "height": 1152
      },
      "poi_business_url": "https://stufd.squarespace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093440648232882614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stufd",
      "poi_latitude": "42.2455852",
      "poi_longitude": "-83.6194637",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-340-6952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82CV-kWoPIgRttEkY7QZOO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_cceeb64cc9f7b122bb94702c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Benito's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1088 N Huron River Dr, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Regional pizzeria chain offering flavored crusts & options ranging from thin-crust to deep-dish.",
      "poi_long_description": "Regional pizzeria chain offering flavored crusts & options ranging from thin-crust to deep-dish.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-cdee-7005-9abb-d53a14a48751.webp",
      "poi_featured_image_media": {
        "alt_text": "Benito's Pizza storefront",
        "public_id": "019d7532-cdee-7005-9abb-d53a14a48751",
        "storage_key": "property/6767906449167447/019d7532-cdee-7005-9abb-d53a14a48751.webp",
        "width": 475,
        "height": 598
      },
      "poi_business_url": "https://www.benitospizzaofypsilanti.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1153493916039401506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benitos-pizza",
      "poi_latitude": "42.2566417",
      "poi_longitude": "-83.6292162",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 734-961-0707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUazG21KoPIgRIlAa7JoIAhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_fd31fc5754f954eb085348d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "La Torre Taqueria",
      "poi_type": "Restaurants",
      "poi_address": "1525 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Laid-back, family-owned operation serving classic Mexican fare such as tacos & burritos.",
      "poi_long_description": "Laid-back, family-owned operation serving classic Mexican fare such as tacos & burritos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-dc55-7329-93ef-489cb6855a9e.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a taqueria with a sign that says Taqueria La Torre and a phone number.",
        "public_id": "019d7532-dc55-7329-93ef-489cb6855a9e",
        "storage_key": "property/6767906449167447/019d7532-dc55-7329-93ef-489cb6855a9e.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://latorretaqueriami.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11012595594477871663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-torre-taqueria",
      "poi_latitude": "42.2470508",
      "poi_longitude": "-83.63801339999999",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 734-905-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0kV1PmoPIgRL6Lij1iZ1Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_7fa4883b748ee39c10eb84cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Cuppy's Best Soul Food",
      "poi_type": "Restaurants",
      "poi_address": "2469 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Fried fish & chicken, Southern sides & desserts, dished up in a basic space with booth seating.",
      "poi_long_description": "Fried fish & chicken, Southern sides & desserts, dished up in a basic space with booth seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-dcbd-725d-aebd-90efaa8a4acf.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Cuppy's Best Soulful Bistro with signage and American flag.",
        "public_id": "019d7532-dcbd-725d-aebd-90efaa8a4acf",
        "storage_key": "property/6767906449167447/019d7532-dcbd-725d-aebd-90efaa8a4acf.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10459891529197908239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cuppys-best-soul-food",
      "poi_latitude": "42.2489053",
      "poi_longitude": "-83.6515943",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 734-961-8384",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5TyBcCpXO4gRD3H1Su3_KJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "ec_4097b181d9cd5f5ec2021a43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsi Alehouse",
      "poi_type": "Restaurants",
      "poi_address": "124 Pearl St #100, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Easygoing hangout in a vintage building offering pub fare, house microbrews on tap & live music.",
      "poi_long_description": "Easygoing hangout in a vintage building offering pub fare, house microbrews on tap & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-f806-717e-a47b-d02f311883e7.webp",
      "poi_featured_image_media": {
        "alt_text": "Ypsi Alehouse building exterior with a snow-covered tree in the foreground.",
        "public_id": "019d7532-f806-717e-a47b-d02f311883e7",
        "storage_key": "property/6767906449167447/019d7532-f806-717e-a47b-d02f311883e7.webp",
        "width": 2048,
        "height": 1152
      },
      "poi_business_url": "http://ypsialehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2902593491665413962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsi-alehouse",
      "poi_latitude": "42.24245",
      "poi_longitude": "-83.61439899999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-487-1555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_UPaUeoPIgRSucT7mYVSCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "ec_bb695e47cf43f47ca5645282",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Khadi's Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "421 W Cross St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Traditional African eatery dishing up lamb, chicken and seafood preparations, plus juices.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-f828-714c-b7a5-bd749b75c781.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage for Khadi's Cuisine restaurant at 421 W. Cross.",
        "public_id": "019d7532-f828-714c-b7a5-bd749b75c781",
        "storage_key": "property/6767906449167447/019d7532-f828-714c-b7a5-bd749b75c781.webp",
        "width": 1444,
        "height": 1600
      },
      "poi_business_url": "https://khadiscuisinemenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11948801067633731826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "khadis-cuisine",
      "poi_latitude": "42.2456105",
      "poi_longitude": "-83.6189885",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-905-7013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
      "poi_map_icon_media": {
        "alt_text": "Black icon of a fork and knife",
        "public_id": "019d752f-a2bb-7343-b84f-6f86b16fca42",
        "storage_key": "property/6767906449167447/019d752f-a2bb-7343-b84f-6f86b16fca42.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJBw6cYrypPIgR8ugdeEOr0qU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_11e51e8e3ce5d6753d4740b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1420 S Huron St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-feba-70f9-b131-49907cb4aa8a.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a grocery store with produce and quick meals displayed.",
        "public_id": "019d7532-feba-70f9-b131-49907cb4aa8a",
        "storage_key": "property/6767906449167447/019d7532-feba-70f9-b131-49907cb4aa8a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://info.aldi.us/stores/l/mi/ypsilanti/1420-s-huron-st/fe92",
      "poi_directions_map_url": "https://maps.google.com/?cid=8266115831742937820&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "42.22035",
      "poi_longitude": "-83.618839",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfgtEwCpPIgR3DpFn40kt3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_23341d774a43782cf5932064",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Fresh Thyme Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2985 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Grocery store specializing in natural and organic food, including prepared items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7532-fe57-76ce-a5e2-140a37be70a5.webp",
      "poi_featured_image_media": {
        "alt_text": "Fresh Thyme Farmers Market building exterior with signage.",
        "public_id": "019d7532-fe57-76ce-a5e2-140a37be70a5",
        "storage_key": "property/6767906449167447/019d7532-fe57-76ce-a5e2-140a37be70a5.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.freshthyme.com/store-location/ypsilanti-michigan-48197/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15706830227764933974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fresh-thyme-market",
      "poi_latitude": "42.2492129",
      "poi_longitude": "-83.6598303",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 734-896-4076",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYKEwNyoPIgRVvVLsd_e-dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_15931a5f04409361978401a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1771 E Michigan Ave, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-061f-716d-b0ef-0a986b06d8cb.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Kroger grocery store and pharmacy.",
        "public_id": "019d7533-061f-716d-b0ef-0a986b06d8cb",
        "storage_key": "property/6767906449167447/019d7533-061f-716d-b0ef-0a986b06d8cb.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/mi/ypsilanti/ypsilanti/018/00520?cid=loc_01800520_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3640588155653678993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "42.2484407",
      "poi_longitude": "-83.57540089999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 734-482-5615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9TCaXslXO4gRkWc7j6P3hTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_1b3ee7e426d351e32eaf640c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Meijer",
      "poi_type": "Shopping & Retail",
      "poi_address": "3825 Carpenter Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-cf34-737c-b5ac-e2a259a08f26.webp",
      "poi_featured_image_media": {
        "alt_text": "Meijer store exterior with a red stripe and the Meijer logo.",
        "public_id": "019d752e-cf34-737c-b5ac-e2a259a08f26",
        "storage_key": "property/6767906449167447/019d752e-cf34-737c-b5ac-e2a259a08f26.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/27.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=1898296138944747909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "42.2334936",
      "poi_longitude": "-83.6766674",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-973-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8egSrOoPIgRhRlM4EcaWBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_cbcea3d6f01c94324f732dd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "3749 Carpenter Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-06f0-76b6-88dc-4dfe0c28ec5b.webp",
      "poi_featured_image_media": {
        "alt_text": "Target store entrance with a large red bullseye logo and sign.",
        "public_id": "019d7533-06f0-76b6-88dc-4dfe0c28ec5b",
        "storage_key": "property/6767906449167447/019d7533-06f0-76b6-88dc-4dfe0c28ec5b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.target.com/sl/ypsilanti-carpenter-road/1285",
      "poi_directions_map_url": "https://maps.google.com/?cid=1299955624811513594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "42.2356004",
      "poi_longitude": "-83.67702849999999",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 734-975-4396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-2f8f96133417.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d752f-a2f9-70ac-82fa-2f8f96133417",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-2f8f96133417.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs4UAuLSoPIgR-kap2MBeChI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_9a1b14583252ed80de7be183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsilanti Food Co-op",
      "poi_type": "Shopping & Retail",
      "poi_address": "312 N River St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Grocer selling organic bulk edibles, plus homemade bread and grab-and-go baked goods from its bakery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-0d9a-747b-a1c9-a63463306f76.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Ypsilanti Food Co-Op building with \"Open\" sign and seasonal decorations.",
        "public_id": "019d7533-0d9a-747b-a1c9-a63463306f76",
        "storage_key": "property/6767906449167447/019d7533-0d9a-747b-a1c9-a63463306f76.webp",
        "width": 3072,
        "height": 1454
      },
      "poi_business_url": "http://www.ypsifoodcoop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17895131934343839389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsilanti-food-co-op",
      "poi_latitude": "42.245166",
      "poi_longitude": "-83.608334",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-483-1520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-h2-TmoPIgRnT5Qi65HWPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b25841f0264f416a05deba3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2151 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-09ab-724b-b496-8775d9465a23.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a pharmacy with shelves stocked with medications and health products.",
        "public_id": "019d7533-09ab-724b-b496-8775d9465a23",
        "storage_key": "property/6767906449167447/019d7533-09ab-724b-b496-8775d9465a23.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/ypsilanti-mi-pharmacies/2151-washtenaw-ypsilanti-mi-48197/storeid=8165?WT.mc_id=LS_GOOGLE_RX_8165",
      "poi_directions_map_url": "https://maps.google.com/?cid=11748820963592534352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "42.2477755",
      "poi_longitude": "-83.64618960000001",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-483-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical symbol",
        "public_id": "019d7534-0b03-749f-956d-caa07aa9b433",
        "storage_key": "property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_fSWeWoPIgRUHmYIGsyDKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9de2764863a9031172a74ad0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2170 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-0bfb-7122-a050-177a8d61950b.webp",
      "poi_featured_image_media": {
        "alt_text": "Walgreens exterior with pharmacy sign and accessible parking.",
        "public_id": "019d7533-0bfb-7122-a050-177a8d61950b",
        "storage_key": "property/6767906449167447/019d7533-0bfb-7122-a050-177a8d61950b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2170+washtenaw+rd-ypsilanti-mi-48197/id=5398",
      "poi_directions_map_url": "https://maps.google.com/?cid=17166586578400354090&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "42.249225",
      "poi_longitude": "-83.6469707",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-485-3899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-7BGOWoPIgRKp-KY4r3O-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_856106fe5c106880e4b91cb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1395 E Michigan Ave, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_long_description": "Gas-station & convenience-store chain with grab-&-go food, plus hot & cold beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-0cd9-77fe-bcc8-0d571b306b2d.webp",
      "poi_featured_image_media": {
        "alt_text": "A spread of 7-Eleven snacks including a Big Gulp, hot dog, taquitos, and mozzarella sticks.",
        "public_id": "019d7533-0cd9-77fe-bcc8-0d571b306b2d",
        "storage_key": "property/6767906449167447/019d7533-0cd9-77fe-bcc8-0d571b306b2d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.speedway.com/locations/mi/ypsilanti/1395-east-michigan-avenue-44548?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2347667559651599688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "42.2459178",
      "poi_longitude": "-83.58352359999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 734-481-0920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b02-7131-a15b-65bb35a403fb.webp",
      "poi_map_icon_media": {
        "alt_text": "Gas pump icon",
        "public_id": "019d7534-0b02-7131-a15b-65bb35a403fb",
        "storage_key": "property/6767906449167447/019d7534-0b02-7131-a15b-65bb35a403fb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJG00NRdBXO4gRSOW9_zSXlCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_84450c6f6f82968f0743386a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "3300 Carpenter Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-cd67-7535-b1f5-ea4d26984203.webp",
      "poi_featured_image_media": {
        "alt_text": "The Home Depot store exterior with entrance and merchandise",
        "public_id": "019d752e-cd67-7535-b1f5-ea4d26984203",
        "storage_key": "property/6767906449167447/019d752e-cd67-7535-b1f5-ea4d26984203.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Ann-Arbor/MI/Ypsilanti/48197/2721?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3547746876920191546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "42.2406939",
      "poi_longitude": "-83.68266179999999",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 734-975-1029",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-2f8f96133417.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019d752f-a2f9-70ac-82fa-2f8f96133417",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-2f8f96133417.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVf9IbayuGYgROlrU3_wgPDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_5636ce0877f02d20feff9a8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Bishop Elementary School",
      "poi_type": "Education",
      "poi_address": "8888 Whittaker Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lincolnk12.org/school-buildings/bishop-elementary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17166708974339945495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bishop-elementary-school",
      "poi_latitude": "42.1598915",
      "poi_longitude": "-83.60312560000001",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 734-484-7074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJudC2smenPIgRF_QK6ttmPO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1a00650bb0d5013a81eb0ae4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Model Elementary School",
      "poi_type": "Education",
      "poi_address": "8850 Whittaker Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3307211202124972948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "model-elementary-school",
      "poi_latitude": "42.160466",
      "poi_longitude": "-83.60145969999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 734-484-7045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOUaTT2anPIgRlAPa4xCT5S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_448abc8a0e97c7f66c5d7690",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Lincoln Middle School",
      "poi_type": "Education",
      "poi_address": "8744 Whittaker Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2834932877759281538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-middle-school",
      "poi_latitude": "42.1610357",
      "poi_longitude": "-83.6095263",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 734-484-7033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk85wemanPIgRgvnqpG60Vyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_dfbcc224e26cbf8b767be26b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Lincoln High School",
      "poi_type": "Education",
      "poi_address": "7425 Willis Rd Room P114, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2322-75b9-bc60-ebbb6051ee72.webp",
      "poi_featured_image_media": {
        "alt_text": "Lincoln High School building exterior with American flag flying.",
        "public_id": "019d7533-2322-75b9-bc60-ebbb6051ee72",
        "storage_key": "property/6767906449167447/019d7533-2322-75b9-bc60-ebbb6051ee72.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.lincolnk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8329697344928137759&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-high-school",
      "poi_latitude": "42.1586267",
      "poi_longitude": "-83.6110635",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 734-484-7004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLbI-HECnPIgRH8L0QpoHmXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_6073cf5cd368f30572a37860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Childs Elementary School",
      "poi_type": "Education",
      "poi_address": "7300 Bemis Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lincolnk12.org/school-buildings/childs-elementary/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8412251269577573366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childs-elementary-school",
      "poi_latitude": "42.1714008",
      "poi_longitude": "-83.61447199999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 734-484-7035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZc6NMw2nPIgR9gOArPVRvnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_ac3c7d8c8949fb6ff41b38f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Perry Elementary School",
      "poi_type": "Education",
      "poi_address": "550 Perry Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ycschools.us/our-schools/pre-k-and-kindergarten/perry-early-learning-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13325934539465290151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "perry-elementary-school",
      "poi_latitude": "42.2327896",
      "poi_longitude": "-83.6204103",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-221-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi2yyZWmoPIgRp_HvHNw677g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_992375a7b28a5bc1a4ccacb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ford Early Learning Center",
      "poi_type": "Education",
      "poi_address": "2440 E Clark Rd, Ypsilanti Township, MI 48198, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ycschools.us/our-schools/pre-k-and-kindergarten/ford-early-learning-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10241215476461896129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ford-early-learning-center",
      "poi_latitude": "42.2571555",
      "poi_longitude": "-83.5625876",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-221-1801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWfCZCk1WO4gRwYG-LjcbII4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_c61f7098af5c445a66a8ec31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Eastern Michigan University",
      "poi_type": "Education",
      "poi_address": "900 Oakwood St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-f515-757c-a0b7-b8667a8989bb.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with a tall tower and a tree in the foreground on a sunny day.",
        "public_id": "019d752e-f515-757c-a0b7-b8667a8989bb",
        "storage_key": "property/6767906449167447/019d752e-f515-757c-a0b7-b8667a8989bb.webp",
        "width": 2048,
        "height": 3072
      },
      "poi_business_url": "https://www.emich.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10739275908861508797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-michigan-university",
      "poi_latitude": "42.2506803",
      "poi_longitude": "-83.624089",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-487-1849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9TNoGyupPIgRvbyZPIqSCZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_73300bb7dff3ecaa2e044d24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Washtenaw Community College",
      "poi_type": "Education",
      "poi_address": "4800 E Huron River Dr, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2449-7665-8e65-26d3ad530fbb.webp",
      "poi_featured_image_media": {
        "alt_text": "People walking and sitting in a park-like courtyard with a large abstract sculpture and yellow umbrellas.",
        "public_id": "019d7533-2449-7665-8e65-26d3ad530fbb",
        "storage_key": "property/6767906449167447/019d7533-2449-7665-8e65-26d3ad530fbb.webp",
        "width": 678,
        "height": 448
      },
      "poi_business_url": "https://www.wccnet.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16982238471511117744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washtenaw-community-college",
      "poi_latitude": "42.2635478",
      "poi_longitude": "-83.6655359",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 734-973-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPeUUHyGpPIgRsI9kAeoHres",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_a39df87879e0f0c1b091844a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Arbor Preparatory High School",
      "poi_type": "Education",
      "poi_address": "6800 Hitchingham Rd, Ypsilanti Township, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2826-7148-982a-0357961a6490.webp",
      "poi_featured_image_media": {
        "alt_text": "Arbor Preparatory High School building exterior with a parking lot and a digital sign displaying an event.",
        "public_id": "019d7533-2826-7148-982a-0357961a6490",
        "storage_key": "property/6767906449167447/019d7533-2826-7148-982a-0357961a6490.webp",
        "width": 3072,
        "height": 2042
      },
      "poi_business_url": "https://www.nhaschools.com/schools/arbor-prep-high-school/en",
      "poi_directions_map_url": "https://maps.google.com/?cid=9740586064687338668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arbor-preparatory-high-school",
      "poi_latitude": "42.1901427",
      "poi_longitude": "-83.62262120000001",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 734-961-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-_HgEbunPIgRrBTPAWuDLYc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5e8f2ed29e87fc0deb68cc1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Riverside Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "76 N Huron St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2895-724a-8739-57ff4acd5d7e.webp",
      "poi_featured_image_media": {
        "alt_text": "Person viewing art exhibition in gallery",
        "public_id": "019d7533-2895-724a-8739-57ff4acd5d7e",
        "storage_key": "property/6767906449167447/019d7533-2895-724a-8739-57ff4acd5d7e.webp",
        "width": 2000,
        "height": 1333
      },
      "poi_business_url": "https://www.riversidearts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12579103541653751261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-arts-center",
      "poi_latitude": "42.2422009",
      "poi_longitude": "-83.6127803",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-480-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSYWGljioPIgR3UUhMQb0ka4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_2b35dd79762a3ac45dfd6091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsilanti Freighthouse",
      "poi_type": "Entertainment",
      "poi_address": "100 Market Pl, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Cozy venue in a former freighthouse, used for gatherings and featuring vendors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-28f8-709c-a46d-bd5be567c132.webp",
      "poi_featured_image_media": {
        "alt_text": "Event space set up with dining tables and chairs.",
        "public_id": "019d7533-28f8-709c-a46d-bd5be567c132",
        "storage_key": "property/6767906449167447/019d7533-28f8-709c-a46d-bd5be567c132.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://cityofypsilanti.com/726/Freighthouse",
      "poi_directions_map_url": "https://maps.google.com/?cid=12838042834693948838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsilanti-freighthouse",
      "poi_latitude": "42.2468541",
      "poi_longitude": "-83.6101887",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-482-9825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8q6EjeoPIgRpoUudfDjKbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_e825763893cd1fb91131e440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Michigan Firehouse Museum and Education Center",
      "poi_type": "Entertainment",
      "poi_address": "110 W Cross St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Relaxed destination showcasing old fire trucks, firefighters' gear and memorabilia, plus a play area for kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-0146-74f3-8d24-881deb892c05.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic red brick building with a tall tower and red garage doors.",
        "public_id": "019d752f-0146-74f3-8d24-881deb892c05",
        "storage_key": "property/6767906449167447/019d752f-0146-74f3-8d24-881deb892c05.webp",
        "width": 770,
        "height": 513
      },
      "poi_business_url": "https://www.michiganfirehousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463894587005139826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michigan-firehouse-museum-and-education-center",
      "poi_latitude": "42.2460659",
      "poi_longitude": "-83.6142273",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-547-0663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon with letter M",
        "public_id": "019d752f-a2f9-70ac-82fa-286754c818c0",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrY9oAEioPIgRcvuGFjLKmtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_b026091b8db21e39a03127b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsilanti Automotive Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Museum highlighting local auto industry history in Michigan, with 30 vintage cars on display.",
      "poi_long_description": "Museum highlighting local auto industry history in Michigan, with 30 vintage cars on display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2a7f-7244-8730-af49aa9b74df.webp",
      "poi_featured_image_media": {
        "alt_text": "Hudson Auto Museum building at dusk with neon sign",
        "public_id": "019d7533-2a7f-7244-8730-af49aa9b74df",
        "storage_key": "property/6767906449167447/019d7533-2a7f-7244-8730-af49aa9b74df.webp",
        "width": 877,
        "height": 492
      },
      "poi_business_url": "http://ypsiautoheritage.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335847896158276871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsilanti-automotive-heritage-museum",
      "poi_latitude": "42.2458594",
      "poi_longitude": "-83.6082433",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-482-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon with letter M",
        "public_id": "019d752f-a2f9-70ac-82fa-286754c818c0",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXs1UzeoPIgRB413fJXiiRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_f79d1c216464aaf29522b1ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsilanti Historical Museum & Archives",
      "poi_type": "Entertainment",
      "poi_address": "220 N Huron St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Local historical museum featuring exhibits on the town's roots in a re-created 1860 building.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2c66-75fa-90ba-3cdbe13d5897.webp",
      "poi_featured_image_media": {
        "alt_text": "Ypsilanti Historical Museum building exterior with signage and lawn.",
        "public_id": "019d7533-2c66-75fa-90ba-3cdbe13d5897",
        "storage_key": "property/6767906449167447/019d7533-2c66-75fa-90ba-3cdbe13d5897.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.ypsihistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11557594173669265182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsilanti-historical-museum--archives",
      "poi_latitude": "42.2447252",
      "poi_longitude": "-83.6128569",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-482-4990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon with letter M",
        "public_id": "019d752f-a2f9-70ac-82fa-286754c818c0",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxAUczioPIgRHk-ui6rSZKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_fce5fb6651cb25de9581bab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "734 Brewing Company",
      "poi_type": "Entertainment",
      "poi_address": "15 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Relaxed, laid-back brewery featuring craft beers along with cocktails and other drinks, plus rotating local art.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-36f2-7348-b454-cf088f08787d.webp",
      "poi_featured_image_media": {
        "alt_text": "The exterior of the 34 Brewing building at night, with patrons at the bar and seating outside.",
        "public_id": "019d7533-36f2-7348-b454-cf088f08787d",
        "storage_key": "property/6767906449167447/019d7533-36f2-7348-b454-cf088f08787d.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://734brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6602041029374511086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "734-brewing-company",
      "poi_latitude": "42.2461955",
      "poi_longitude": "-83.6108544",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-340-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2WRmJipPIgR7gdsTFYpn1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_f0ef8f5f8e5d78bb755feb86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Sidetrack Bar and Grill",
      "poi_type": "Entertainment",
      "poi_address": "56 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Lively railroad-themed bar with deck serves handmade burgers & local beer amid taxidermied trophies.",
      "poi_long_description": "Lively railroad-themed bar with deck serves handmade burgers & local beer amid taxidermied trophies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-d776-77dd-9ea4-5210028885d3.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior storefront of Sidetrack restaurant, a historic building with a red door and large windows.",
        "public_id": "019d752e-d776-77dd-9ea4-5210028885d3",
        "storage_key": "property/6767906449167447/019d752e-d776-77dd-9ea4-5210028885d3.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.sidetrackbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11541650875217029556&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sidetrack-bar-and-grill",
      "poi_latitude": "42.245798",
      "poi_longitude": "-83.60896699999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-483-1035",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7r7ni-oPIgRtCnjGlIuLKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_07c842116a24f212c7ef2b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Arbor Brewing Company - Corner Brewery",
      "poi_type": "Entertainment",
      "poi_address": "720 Norris St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Casual pub at Arbor Brewing Company's distribution hub offers counter service for pints & pub grub.",
      "poi_long_description": "Casual pub at Arbor Brewing Company's distribution hub offers counter service for pints & pub grub.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-cdd1-724c-8fa4-ec0c23a83dab.webp",
      "poi_featured_image_media": {
        "alt_text": "Corner Brewery building exterior signage.",
        "public_id": "019d752e-cdd1-724c-8fa4-ec0c23a83dab",
        "storage_key": "property/6767906449167447/019d752e-cdd1-724c-8fa4-ec0c23a83dab.webp",
        "width": 800,
        "height": 536
      },
      "poi_business_url": "http://www.arborbrewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2929851001627387768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arbor-brewing-company---corner-brewery",
      "poi_latitude": "42.25031600000001",
      "poi_longitude": "-83.609956",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-480-2739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019d752f-a2bd-71c9-a17a-457b80b2b626",
        "storage_key": "property/6767906449167447/019d752f-a2bd-71c9-a17a-457b80b2b626.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgdpSmzaoPIgReKfShPbrqCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "ec_df1717901f0db82d0a4d4c84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Putt-R-Round Mini Golf & Putt Arcade",
      "poi_type": "Entertainment",
      "poi_address": "130 W Michigan Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Relaxed, fun, indoor venue featuring a miniature golf course and arcade games of skill that are played for tickets, good for dates and families.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-49aa-704b-8f51-c045bbae9dcf.webp",
      "poi_featured_image_media": {
        "alt_text": "Mini golf course set up indoors with various obstacles and a billiards table.",
        "public_id": "019d7533-49aa-704b-8f51-c045bbae9dcf",
        "storage_key": "property/6767906449167447/019d7533-49aa-704b-8f51-c045bbae9dcf.webp",
        "width": 810,
        "height": 456
      },
      "poi_business_url": "http://puttrround.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15362536329889784509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "putt-r-round-mini-golf--putt-arcade",
      "poi_latitude": "42.241176",
      "poi_longitude": "-83.614402",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cJqNQCpPIgRvSId2GWxMtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "ec_6f13a060524a5f9155e19c14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Michigan Flight Museum",
      "poi_type": "Entertainment",
      "poi_address": "47884 D St, Belleville, MI 48111, USA",
      "poi_short_description": "Aviation museum focused on WWII hosts exhibits & offers pre-booked flights in classic bombers.",
      "poi_long_description": "Aviation museum focused on WWII hosts exhibits & offers pre-booked flights in classic bombers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-0147-70fb-91ff-465b03760e91.webp",
      "poi_featured_image_media": {
        "alt_text": "Children exploring the cockpit of an airplane.",
        "public_id": "019d752f-0147-70fb-91ff-465b03760e91",
        "storage_key": "property/6767906449167447/019d752f-0147-70fb-91ff-465b03760e91.webp",
        "width": 800,
        "height": 445
      },
      "poi_business_url": "https://miflightmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8200901992102745873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michigan-flight-museum",
      "poi_latitude": "42.23911409999999",
      "poi_longitude": "-83.5082831",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-483-4030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic building icon with letter M",
        "public_id": "019d752f-a2f9-70ac-82fa-286754c818c0",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-286754c818c0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aakvDJXO4gREdcTXel0z3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_9b1e4e3ea4fbb20a9023789a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Forest Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "135 S Prospect St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-4954-71fc-bdd8-3967a19e91ca.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a large, multi-story brick building with concrete accents and numerous windows.",
        "public_id": "019d7533-4954-71fc-bdd8-3967a19e91ca",
        "storage_key": "property/6767906449167447/019d7533-4954-71fc-bdd8-3967a19e91ca.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://www.fhmc-mi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16186466547624144323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-health-medical-center",
      "poi_latitude": "42.2373632",
      "poi_longitude": "-83.6007808",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-547-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d752f-a2f9-70ac-82fa-270f0ce1a669",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJX3QGAyOoPIgRw23hw5DhoeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_cb30cf1c37ada2924177808c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Trinity Health Ann Arbor Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 McAuley Dr, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-3b7f-71d8-aa6b-0695cfc6eb4d.webp",
      "poi_featured_image_media": {
        "alt_text": "St. Joseph Mercy Hospital building exterior with brick facade and large windows.",
        "public_id": "019d752f-3b7f-71d8-aa6b-0695cfc6eb4d",
        "storage_key": "property/6767906449167447/019d752f-3b7f-71d8-aa6b-0695cfc6eb4d.webp",
        "width": 1778,
        "height": 1000
      },
      "poi_business_url": "https://www.trinityhealthmichigan.org/location/trinity-health-ann-arbor-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=564934937114168178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-health-ann-arbor-hospital",
      "poi_latitude": "42.2645802",
      "poi_longitude": "-83.65309909999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 734-712-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d752f-a2f9-70ac-82fa-270f0ce1a669",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnU0UvhipPIgRcsvlB1UN1wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_75819da29890a8dbc846b7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Trinity Health IHA Urgent Care - EMU",
      "poi_type": "Health and Wellness",
      "poi_address": "1065 N Huron River Dr Suite 200, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-4b58-703a-a252-94e744e31e98.webp",
      "poi_featured_image_media": {
        "alt_text": "Health Center @ EMU Urgent Care building exterior with signage.",
        "public_id": "019d7533-4b58-703a-a252-94e744e31e98",
        "storage_key": "property/6767906449167447/019d7533-4b58-703a-a252-94e744e31e98.webp",
        "width": 1898,
        "height": 1068
      },
      "poi_business_url": "https://www.trinityhealthmichigan.org/location/trinity-health-iha-urgent-care-emu",
      "poi_directions_map_url": "https://maps.google.com/?cid=10951318541945796959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-health-iha-urgent-care---emu",
      "poi_latitude": "42.2554946",
      "poi_longitude": "-83.62842309999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 734-896-4112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXyvV_apPIgRX_nT-jDm-pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b47dd424ff42dc87a4ec8a92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Doctors Urgent Care Ypsilanti - Ypsilanti Urgent Care & Telemedicine",
      "poi_type": "Health and Wellness",
      "poi_address": "301 W Michigan Ave #100, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-51eb-7319-8716-54a8da8bb378.webp",
      "poi_featured_image_media": {
        "alt_text": "Urgent Care Walk-In Clinic building exterior at night",
        "public_id": "019d7533-51eb-7319-8716-54a8da8bb378",
        "storage_key": "property/6767906449167447/019d7533-51eb-7319-8716-54a8da8bb378.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.urgentcareypsilanti.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17199080885327416931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doctors-urgent-care-ypsilanti---ypsilanti-urgent-care--telemedicine",
      "poi_latitude": "42.2406876",
      "poi_longitude": "-83.61670319999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-221-5440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhVJZKUGoPIgRY84myfBor-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e12b9c69965c19cdf458ccb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2151 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-09ab-724b-b496-8775d9465a23.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a pharmacy with shelves stocked with medications and health products.",
        "public_id": "019d7533-09ab-724b-b496-8775d9465a23",
        "storage_key": "property/6767906449167447/019d7533-09ab-724b-b496-8775d9465a23.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/ypsilanti-mi-pharmacies/2151-washtenaw-ypsilanti-mi-48197/storeid=8165?WT.mc_id=LS_GOOGLE_RX_8165",
      "poi_directions_map_url": "https://maps.google.com/?cid=11748820963592534352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "42.2477755",
      "poi_longitude": "-83.64618960000001",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-483-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical symbol",
        "public_id": "019d7534-0b03-749f-956d-caa07aa9b433",
        "storage_key": "property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1_fSWeWoPIgRUHmYIGsyDKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d3843c85e89c45155abbaa8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "ANN ARBOR PROFESSIONAL PHARMACY",
      "poi_type": "Health and Wellness",
      "poi_address": "6 W Michigan Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-5906-775a-becb-a94e19c26390.webp",
      "poi_featured_image_media": {
        "alt_text": "Waiting area with two black chairs, a small cooler, and a bulletin board.",
        "public_id": "019d7533-5906-775a-becb-a94e19c26390",
        "storage_key": "property/6767906449167447/019d7533-5906-775a-becb-a94e19c26390.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.a2p2rx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15845910302139413418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ann-arbor-professional-pharmacy",
      "poi_latitude": "42.2412261",
      "poi_longitude": "-83.6121797",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-477-9006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical symbol",
        "public_id": "019d7534-0b03-749f-956d-caa07aa9b433",
        "storage_key": "property/6767906449167447/019d7534-0b03-749f-956d-caa07aa9b433.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwcgtjioPIgRqvO47Xb759s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_e8f8bf199bad945c19b38607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Trinity Health Pharmacy - Reichert Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5333 McAuley Dr, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.trinityhealthmichigan.org/location/trinity-health-pharmacy-reichert-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14873738364936447611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-health-pharmacy---reichert-center",
      "poi_latitude": "42.26",
      "poi_longitude": "-83.64999999999999",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 734-712-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebkNKbWpPIgRe-YiDD0ias4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_e3b5540722f896d7acbb90c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Crunch Fitness - Ypsilanti",
      "poi_type": "Health and Wellness",
      "poi_address": "3020 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Casual fitness center featuring cardio machines, free weights and group classes, plus personal training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-22d6-7506-b7b4-3bc822fb7930.webp",
      "poi_featured_image_media": {
        "alt_text": "Fitness center with weightlifting equipment and people working out.",
        "public_id": "019d752f-22d6-7506-b7b4-3bc822fb7930",
        "storage_key": "property/6767906449167447/019d752f-22d6-7506-b7b4-3bc822fb7930.webp",
        "width": 1708,
        "height": 750
      },
      "poi_business_url": "http://www.crunchypsilanti.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5283921827157945593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---ypsilanti",
      "poi_latitude": "42.2508109",
      "poi_longitude": "-83.6584163",
      "poi_miles_from_property": "8.9 mi",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 734-221-3633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCTfcxTipPIgR-ayuCOhCVEk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_567cf89ee545b7f8303ab838",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2748 Washtenaw Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, tanning beds, and hydromassage.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-0db7-70e5-81ab-83e3bea85c46.webp",
      "poi_featured_image_media": {
        "alt_text": "People working out at a brightly lit gym with purple and yellow equipment.",
        "public_id": "019d752f-0db7-70e5-81ab-83e3bea85c46",
        "storage_key": "property/6767906449167447/019d752f-0db7-70e5-81ab-83e3bea85c46.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ypsilanti-mi?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=8848320834368484498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "42.25177",
      "poi_longitude": "-83.65362999999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 734-390-0139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5MKvOeoPIgRkrQ4H-uMy3o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_e4ed4481a799451745db13d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsi Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "208 W Michigan Ave, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-5ae2-76f5-8e68-98ddc9d82112.webp",
      "poi_featured_image_media": {
        "alt_text": "Indoor spin class studio with rows of stationary bikes and brick walls.",
        "public_id": "019d7533-5ae2-76f5-8e68-98ddc9d82112",
        "storage_key": "property/6767906449167447/019d7533-5ae2-76f5-8e68-98ddc9d82112.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15086054286814454259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsi-studio",
      "poi_latitude": "42.2411731",
      "poi_longitude": "-83.6150375",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 734-845-0542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYyJvNkeoPIgR86HVy3FuXNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_07dd135a386a4bc830b256a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ford Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8399 Textile Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Public green space featuring a playground, wooded trails & fields for baseball & soccer.",
      "poi_long_description": "Public green space featuring a playground, wooded trails & fields for baseball & soccer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-5aff-76ea-8c46-50cba58699e0.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground equipment with slides, swings, and climbing structures.",
        "public_id": "019d7533-5aff-76ea-8c46-50cba58699e0",
        "storage_key": "property/6767906449167447/019d7533-5aff-76ea-8c46-50cba58699e0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://ytown.org/park-system#ford-heritage-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14230248191859969067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ford-heritage-park",
      "poi_latitude": "42.205823",
      "poi_longitude": "-83.59820719999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 734-544-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEdT3OvqnPIgRK0x13VX_e8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_951adbe2a17a6c549f2dc990",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ford Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9075 S Huron River Dr, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Public park offering a playground, tennis and basketball courts, hiking and biking trails, and picnic areas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-48ba-74f2-b112-4937d330a2c0.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures.",
        "public_id": "019d752f-48ba-74f2-b112-4937d330a2c0",
        "storage_key": "property/6767906449167447/019d752f-48ba-74f2-b112-4937d330a2c0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://ypsitownship.org/departments/recreation___parks/parks.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=13245421361404534633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ford-lake-park",
      "poi_latitude": "42.2090335",
      "poi_longitude": "-83.5776188",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 734-484-0073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpWHgGBxYO4gRaV_jCo0w0bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_b576a2a9d09737d355ed72ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "North Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1151 S Huron St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "139-acre lakefront park offering fishing, wildlife & boardwalk/dirt trails through woods & wetlands.",
      "poi_long_description": "139-acre lakefront park offering fishing, wildlife & boardwalk/dirt trails through woods & wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-3fc3-70c3-9f8d-b9e56f61219c.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk along a calm lake with trees and blue sky.",
        "public_id": "019d752f-3fc3-70c3-9f8d-b9e56f61219c",
        "storage_key": "property/6767906449167447/019d752f-3fc3-70c3-9f8d-b9e56f61219c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://ytown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10667719684499014631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-bay-park",
      "poi_latitude": "42.227963",
      "poi_longitude": "-83.613131",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 734-544-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY95q3BKoPIgR54MBdohaC5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_3ae4ba8182f30d8e92965ab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Loon Feather Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1320 Grove Rd, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Scenic lakeside attraction featuring playgrounds, shelters, soccer fields, fishing, picnic tables and dog walking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-6eda-721f-8555-b65450fb73b6.webp",
      "poi_featured_image_media": {
        "alt_text": "Wavy lake with trees and buildings in the background.",
        "public_id": "019d7533-6eda-721f-8555-b65450fb73b6",
        "storage_key": "property/6767906449167447/019d7533-6eda-721f-8555-b65450fb73b6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://ytown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13285312269961372019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loon-feather-point-park",
      "poi_latitude": "42.2213375",
      "poi_longitude": "-83.5839975",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 734-544-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJox6CJfpXO4gRc6Ev9R7pXrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_338a2af37c201be7a5e7964b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "North Hydro Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2599 Bridge Rd, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Tranquil, clean option featuring picnic tables, grills and scenic views.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-6f4b-774a-9901-f9249de9dfac.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk leading to a dock on a lake.",
        "public_id": "019d7533-6f4b-774a-9901-f9249de9dfac",
        "storage_key": "property/6767906449167447/019d7533-6f4b-774a-9901-f9249de9dfac.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://ytown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16285704652077679124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-hydro-park",
      "poi_latitude": "42.2077005",
      "poi_longitude": "-83.5543127",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 734-484-0073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_2PwStYO4gRFEIEgBhyAuI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1c253b99720cc7da0305262e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "North Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1151 S Huron St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "139-acre lakefront park offering fishing, wildlife & boardwalk/dirt trails through woods & wetlands.",
      "poi_long_description": "139-acre lakefront park offering fishing, wildlife & boardwalk/dirt trails through woods & wetlands.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-3fc3-70c3-9f8d-b9e56f61219c.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk along a calm lake with trees and blue sky.",
        "public_id": "019d752f-3fc3-70c3-9f8d-b9e56f61219c",
        "storage_key": "property/6767906449167447/019d752f-3fc3-70c3-9f8d-b9e56f61219c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://ytown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10667719684499014631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-bay-park",
      "poi_latitude": "42.227963",
      "poi_longitude": "-83.613131",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 734-544-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY95q3BKoPIgR54MBdohaC5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_d45536a2c579065ff998d558",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Frog Island Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "699 Rice St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "5-acre green space with an amphitheater & a community garden, plus a soccer field & running track.",
      "poi_long_description": "5-acre green space with an amphitheater & a community garden, plus a soccer field & running track.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-82ba-713f-ba45-c2f49a224170.webp",
      "poi_featured_image_media": {
        "alt_text": "River with autumn foliage on the banks",
        "public_id": "019d7533-82ba-713f-ba45-c2f49a224170",
        "storage_key": "property/6767906449167447/019d7533-82ba-713f-ba45-c2f49a224170.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://cityofypsilanti.com/facilities/facility/details/Frog-Island-Park-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=7855361265400018542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frog-island-park",
      "poi_latitude": "42.2473865",
      "poi_longitude": "-83.6119544",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-483-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQ5qCzeoPIgRbvaHjnPZA20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_e81692e9fe0e72c0235e84c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2 E Cross St, Ypsilanti, MI 48198, USA",
      "poi_short_description": "Community park hosting regular local events as well as offering fishing & biking trails.",
      "poi_long_description": "Community park hosting regular local events as well as offering fishing & biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-813e-7769-87c1-cbefd059c31e.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures.",
        "public_id": "019d7533-813e-7769-87c1-cbefd059c31e",
        "storage_key": "property/6767906449167447/019d7533-813e-7769-87c1-cbefd059c31e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://cityofypsilanti.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=6988331365098246971&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "42.2457193",
      "poi_longitude": "-83.6126522",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-483-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWXD-9TeoPIgRO9NmzVmK-2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_655f7749321a13d3185596b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Prospect Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "550 N Prospect Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "9.5-acre community park includes sports fields & courts, a playground, picnic area & wooded trails.",
      "poi_long_description": "9.5-acre community park includes sports fields & courts, a playground, picnic area & wooded trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-819f-7489-9ff9-ea38bda8659a.webp",
      "poi_featured_image_media": {
        "alt_text": "A large black cannon sits in the foreground of a park with a playground and trees in the background.",
        "public_id": "019d7533-819f-7489-9ff9-ea38bda8659a",
        "storage_key": "property/6767906449167447/019d7533-819f-7489-9ff9-ea38bda8659a.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://cityofypsilanti.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=16682663819962848033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prospect-park",
      "poi_latitude": "42.2473074",
      "poi_longitude": "-83.6021896",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 734-483-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcYj1S-oPIgRIZMlEFu6hOc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2438b9270c9e8c941e70c261",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Rolling Hills",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7660 Stony Creek Rd, Ypsilanti Township, MI 48197, USA",
      "poi_short_description": "Year round park offers hiking & skiing trails, generous space for outdoor activities & a water park.",
      "poi_long_description": "Year round park offers hiking & skiing trails, generous space for outdoor activities & a water park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-45a1-74db-b8e3-1d3c607c36db.webp",
      "poi_featured_image_media": {
        "alt_text": "People enjoying a wave pool at a park.",
        "public_id": "019d752f-45a1-74db-b8e3-1d3c607c36db",
        "storage_key": "property/6767906449167447/019d752f-45a1-74db-b8e3-1d3c607c36db.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.washtenaw.org/rollinghills",
      "poi_directions_map_url": "https://maps.google.com/?cid=4687713217460561829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rolling-hills",
      "poi_latitude": "42.1763099",
      "poi_longitude": "-83.6509471",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-484-9676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
      "poi_map_icon_media": {
        "alt_text": "Christmas tree icon",
        "public_id": "019d752f-a6d7-74b7-958d-ebcedf5601c0",
        "storage_key": "property/6767906449167447/019d752f-a6d7-74b7-958d-ebcedf5601c0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3UDnwfimPIgRpeejr1UaDkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6041133a64ab775c9ee7e869",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ypsilanti Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "220 Pearl St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-9324-71eb-8603-f642b38b853d.webp",
      "poi_featured_image_media": {
        "alt_text": "A public bus with the number 491 on the back is parked on the side of the road.",
        "public_id": "019d7533-9324-71eb-8603-f642b38b853d",
        "storage_key": "property/6767906449167447/019d7533-9324-71eb-8603-f642b38b853d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.theride.org/about/projects/ypsilanti-transit-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6175297960543766635&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ypsilanti-transit-center",
      "poi_latitude": "42.2423842",
      "poi_longitude": "-83.6157696",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 734-973-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
      "poi_map_icon_media": {
        "alt_text": "Black letter P graphic",
        "public_id": "019d7534-0b0d-707e-a504-76e33a9fd4ab",
        "storage_key": "property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJccqbEEeoPIgRa8hn6MYQs1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_b9c6111d9ce6d408c245bd43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Meijer",
      "poi_type": "Transportation & Transit",
      "poi_address": "3825 Carpenter Rd, Ypsilanti, MI 48197, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-cf34-737c-b5ac-e2a259a08f26.webp",
      "poi_featured_image_media": {
        "alt_text": "Meijer store exterior with a red stripe and the Meijer logo.",
        "public_id": "019d752e-cf34-737c-b5ac-e2a259a08f26",
        "storage_key": "property/6767906449167447/019d752e-cf34-737c-b5ac-e2a259a08f26.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/27.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=1898296138944747909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "42.2334936",
      "poi_longitude": "-83.6766674",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-973-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019d752f-a303-752d-8f39-92d26672e52b",
        "storage_key": "property/6767906449167447/019d752f-a303-752d-8f39-92d26672e52b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8egSrOoPIgRhRlM4EcaWBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_bef0cd3497bc4073e104816b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Willow Run Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Willow Run Airport, Superior Township, MI 48198, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-5cae-779e-9ff6-1b6c44915ccf.webp",
      "poi_featured_image_media": {
        "alt_text": "People watch a vintage airplane perform a flyby at an outdoor event.",
        "public_id": "019d752f-5cae-779e-9ff6-1b6c44915ccf",
        "storage_key": "property/6767906449167447/019d752f-5cae-779e-9ff6-1b6c44915ccf.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.willowrunairport.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=18025213558827094067&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-run-airport",
      "poi_latitude": "42.2378031",
      "poi_longitude": "-83.5242868",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-485-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a817-70c3-8bca-39d0fabf69a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d752f-a817-70c3-8bca-39d0fabf69a8",
        "storage_key": "property/6767906449167447/019d752f-a817-70c3-8bca-39d0fabf69a8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJvUaLOxRXO4gRM5Bx5jpsJvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_274533384deb5df502b46649",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Detroit Metropolitan Wayne County Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 W. G. Rogell Dr. Building 602, Detroit, MI 48242, USA",
      "poi_short_description": "Airport featuring an underground tunnel with a color-changing LED light show synchronized to music.",
      "poi_long_description": "Airport featuring an underground tunnel with a color-changing LED light show synchronized to music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-a200-71de-ba23-d6f2de8b83f3.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of an airport terminal with a moving walkway and people walking.",
        "public_id": "019d7533-a200-71de-ba23-d6f2de8b83f3",
        "storage_key": "property/6767906449167447/019d7533-a200-71de-ba23-d6f2de8b83f3.webp",
        "width": 520,
        "height": 416
      },
      "poi_business_url": "https://www.metroairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2540523660737747195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "detroit-metropolitan-wayne-county-airport",
      "poi_latitude": "42.2132203",
      "poi_longitude": "-83.3524824",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "5 hours 58 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 734-247-7678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a817-70c3-8bca-39d0fabf69a8.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019d752f-a817-70c3-8bca-39d0fabf69a8",
        "storage_key": "property/6767906449167447/019d752f-a817-70c3-8bca-39d0fabf69a8.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbPw2l1PO4gR-5i_Jc_AQSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_7fa9b4a2fd35ea3e5f31fe01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Ann Arbor Amtrak Train Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Amtrak Station, 325 Depot St, Ann Arbor, MI 48104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-a4c4-7249-97ec-9e2c7b4f0a14.webp",
      "poi_featured_image_media": {
        "alt_text": "Train station platform with bridge and tracks at sunset",
        "public_id": "019d7533-a4c4-7249-97ec-9e2c7b4f0a14",
        "storage_key": "property/6767906449167447/019d7533-a4c4-7249-97ec-9e2c7b4f0a14.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.amtrak.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5237062027330377410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ann-arbor-amtrak-train-station",
      "poi_latitude": "42.28774720000001",
      "poi_longitude": "-83.7432532",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 1 min",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZjVdT2uPIgRwta2rSrIrUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_319f80196998b4f7c0bcecfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Washtenaw County Service Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4125 Washtenaw Ave, Ann Arbor, MI 48108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-afb2-7094-bcb4-ebe1c81e191b.webp",
      "poi_featured_image_media": {
        "alt_text": "Person in front of Washtenaw County Sheriff building",
        "public_id": "019d7533-afb2-7094-bcb4-ebe1c81e191b",
        "storage_key": "property/6767906449167447/019d7533-afb2-7094-bcb4-ebe1c81e191b.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.washtenaw.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10085308110779550380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washtenaw-county-service-center",
      "poi_latitude": "42.25600559999999",
      "poi_longitude": "-83.6793928",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-973-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
      "poi_map_icon_media": {
        "alt_text": "Black letter P graphic",
        "public_id": "019d7534-0b0d-707e-a504-76e33a9fd4ab",
        "storage_key": "property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJP62GqSyvPIgRrIph4Uo29os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_c34a2dd7f2d8acce8faa4aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "AA mail. 1919 Green Rd",
      "poi_type": "Transportation & Transit",
      "poi_address": "1919 Green Rd, Ann Arbor, MI 48109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-a9e3-73fc-8f20-9cc79181eacd.webp",
      "poi_featured_image_media": {
        "alt_text": "Snow covered parking lot at night with a white van and a pickup truck.",
        "public_id": "019d7533-a9e3-73fc-8f20-9cc79181eacd",
        "storage_key": "property/6767906449167447/019d7533-a9e3-73fc-8f20-9cc79181eacd.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1008396972479694703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aa-mail-1919-green-rd",
      "poi_latitude": "42.3000234",
      "poi_longitude": "-83.6940189",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
      "poi_map_icon_media": {
        "alt_text": "Black letter P graphic",
        "public_id": "019d7534-0b0d-707e-a504-76e33a9fd4ab",
        "storage_key": "property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJfxAhEB6sPIgRb0c7KbSL_g0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_498ee76d5cadae634bb7b2da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Plymouth Road Park And Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Plymouth Road Park and Ride Lot, 3700 Plymouth Rd, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-bbbe-74c9-b65e-21b0f1fb1214.webp",
      "poi_featured_image_media": {
        "alt_text": "Sign for Plymouth Road Park and Ride Lot, managed by TheRide and Ann Arbor Transportation Authority.",
        "public_id": "019d7533-bbbe-74c9-b65e-21b0f1fb1214",
        "storage_key": "property/6767906449167447/019d7533-bbbe-74c9-b65e-21b0f1fb1214.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.theride.org/services/commuter-services/park-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=12330989008338585185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plymouth-road-park-and-ride",
      "poi_latitude": "42.3053007",
      "poi_longitude": "-83.68844829999999",
      "poi_miles_from_property": "13.9 mi",
      "poi_walking_minutes": "5 hours 6 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
      "poi_map_icon_media": {
        "alt_text": "Black letter P graphic",
        "public_id": "019d7534-0b0d-707e-a504-76e33a9fd4ab",
        "storage_key": "property/6767906449167447/019d7534-0b0d-707e-a504-76e33a9fd4ab.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ94hfNhusPIgRYYZEsyt5IKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_8fcb84b900bbeac81876f449",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Blake Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Ann Arbor, MI 48104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-bab0-7667-9158-b467dca16ec9.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the Blake Transit Center with a parking garage in the background.",
        "public_id": "019d7533-bab0-7667-9158-b467dca16ec9",
        "storage_key": "property/6767906449167447/019d7533-bab0-7667-9158-b467dca16ec9.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.theride.org/AboutUs/Initiatives/BlakeTransitCenter",
      "poi_directions_map_url": "https://maps.google.com/?cid=8519393239052192898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blake-transit-center",
      "poi_latitude": "42.2784181",
      "poi_longitude": "-83.7469959",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5ZAuDjyuPIgRggySYwP3OnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_f3984efbdc684a6928c19072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Student Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "900 Oakwood St #370, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-cf02-7682-8844-0ed912f93dc1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a modern brick building with large glass windows and balconies, featuring an Amazon logo and an outdoor seating area.",
        "public_id": "019d7533-cf02-7682-8844-0ed912f93dc1",
        "storage_key": "property/6767906449167447/019d7533-cf02-7682-8844-0ed912f93dc1.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.emich.edu/studentcenter/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=2777384247938046910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "student-center",
      "poi_latitude": "42.2516663",
      "poi_longitude": "-83.62741439999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-487-1157",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49Qu2FOoPIgRvtscH0JAiyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_164c6132e8f55ef4a7913ec3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Eastern Michigan University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "900 Oakwood St, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752e-f515-757c-a0b7-b8667a8989bb.webp",
      "poi_featured_image_media": {
        "alt_text": "Brick building with a tall tower and a tree in the foreground on a sunny day.",
        "public_id": "019d752e-f515-757c-a0b7-b8667a8989bb",
        "storage_key": "property/6767906449167447/019d752e-f515-757c-a0b7-b8667a8989bb.webp",
        "width": 2048,
        "height": 3072
      },
      "poi_business_url": "https://www.emich.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10739275908861508797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastern-michigan-university",
      "poi_latitude": "42.2506803",
      "poi_longitude": "-83.624089",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 734-487-1849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9TNoGyupPIgRvbyZPIqSCZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_4b1a8e36a784b24123ff7a96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Trinity Health Ann Arbor Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5301 McAuley Dr, Ypsilanti, MI 48197, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-3b7f-71d8-aa6b-0695cfc6eb4d.webp",
      "poi_featured_image_media": {
        "alt_text": "St. Joseph Mercy Hospital building exterior with brick facade and large windows.",
        "public_id": "019d752f-3b7f-71d8-aa6b-0695cfc6eb4d",
        "storage_key": "property/6767906449167447/019d752f-3b7f-71d8-aa6b-0695cfc6eb4d.webp",
        "width": 1778,
        "height": 1000
      },
      "poi_business_url": "https://www.trinityhealthmichigan.org/location/trinity-health-ann-arbor-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=564934937114168178&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-health-ann-arbor-hospital",
      "poi_latitude": "42.2645802",
      "poi_longitude": "-83.65309909999999",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 734-712-3456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d752f-a2f9-70ac-82fa-270f0ce1a669",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnU0UvhipPIgRcsvlB1UN1wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_527eb1c0a3c19b22d7c274f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "University of Michigan Health",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 E Medical Center Dr, Ann Arbor, MI 48109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-cfbc-765c-8d1b-15d4a296979d.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a large building complex with surrounding green space and walkways.",
        "public_id": "019d7533-cfbc-765c-8d1b-15d4a296979d",
        "storage_key": "property/6767906449167447/019d7533-cfbc-765c-8d1b-15d4a296979d.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.uofmhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13348171703376841351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-michigan-health",
      "poi_latitude": "42.2837581",
      "poi_longitude": "-83.7311527",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 47 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 734-936-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d752f-a2f9-70ac-82fa-270f0ce1a669",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0YtAjWiuPIgRh4qyTHE7Prk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_a378bf83b7ad32bed6ea6d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "University of Michigan - Central Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "515 E Jefferson St, Ann Arbor, MI 48109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-cf47-71cb-9301-5d8758306426.webp",
      "poi_featured_image_media": {
        "alt_text": "A bicycle parked in the snow next to a lamppost with buildings in the background.",
        "public_id": "019d7533-cf47-71cb-9301-5d8758306426",
        "storage_key": "property/6767906449167447/019d7533-cf47-71cb-9301-5d8758306426.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://umich.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17759499335155765216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-michigan---central-campus",
      "poi_latitude": "42.276561",
      "poi_longitude": "-83.74256419999999",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 734-764-1817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCbVHxziuPIgR4M--LI1qdvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_6b1147d159202795815f3e46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Washtenaw County Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 N Main St, Ann Arbor, MI 48104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-cfaa-76c2-97ca-f4bd5fd57afb.webp",
      "poi_featured_image_media": {
        "alt_text": "Two orange ladders leaning against a brick building.",
        "public_id": "019d7533-cfaa-76c2-97ca-f4bd5fd57afb",
        "storage_key": "property/6767906449167447/019d7533-cfaa-76c2-97ca-f4bd5fd57afb.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "https://www.washtenaw.org/150/Administrator",
      "poi_directions_map_url": "https://maps.google.com/?cid=12517315658657420742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washtenaw-county-administration",
      "poi_latitude": "42.2830511",
      "poi_longitude": "-83.7482204",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 0 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 734-222-6850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2b5-72a9-a510-13eafa3a91df.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d752f-a2b5-72a9-a510-13eafa3a91df",
        "storage_key": "property/6767906449167447/019d752f-a2b5-72a9-a510-13eafa3a91df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDRFxiD2uPIgRxtW1n0Vwtq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_24ccec117a81267a5409ca41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Domino's Pizza World Human Resource Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30 Frank Lloyd Wright Dr, Ann Arbor, MI 48105, USA",
      "poi_short_description": "Delivery/carryout chain offering a wide range of pizza, plus chicken wings & other sides.",
      "poi_long_description": "Delivery/carryout chain offering a wide range of pizza, plus chicken wings & other sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-ef00-76ec-8f01-7c4c6cecd634.webp",
      "poi_featured_image_media": {
        "alt_text": "Domino's Pizza interior with a large logo.",
        "public_id": "019d7533-ef00-76ec-8f01-7c4c6cecd634",
        "storage_key": "property/6767906449167447/019d7533-ef00-76ec-8f01-7c4c6cecd634.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://biz.dominos.com/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3740965133158279859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza-world-human-resource-center",
      "poi_latitude": "42.3180795",
      "poi_longitude": "-83.6820627",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 16 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 734-930-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_vSvXSsPIgRs2oF1_eT6jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_27db0e5414f3d140bfb0b36d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Toyota Motor North America, Research and Development",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1555 Woodridge Ave, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.toyota.com/usa/operations/map/ttc_ann_arbor_and_saline",
      "poi_directions_map_url": "https://maps.google.com/?cid=14656576074381905041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-north-america-research-and-development",
      "poi_latitude": "42.2970854",
      "poi_longitude": "-83.67701009999999",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019d752f-a2fb-7429-84e2-1d7b82e1f9f3",
        "storage_key": "property/6767906449167447/019d752f-a2fb-7429-84e2-1d7b82e1f9f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmc916oKpPIgRkcwFKUmeZss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_62c22bd2d00035d4f45ec63d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "National Vehicle and Fuel Emissions Laboratory (U.S. EPA)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2565 Plymouth Rd, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-ef06-745a-84be-d36a1295dcfc.webp",
      "poi_featured_image_media": {
        "alt_text": "View of the EPA building's exterior with a black fence and green lawn.",
        "public_id": "019d7533-ef06-745a-84be-d36a1295dcfc",
        "storage_key": "property/6767906449167447/019d7533-ef06-745a-84be-d36a1295dcfc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.epa.gov/aboutepa/about-national-vehicle-and-fuel-emissions-laboratory-nvfel",
      "poi_directions_map_url": "https://maps.google.com/?cid=15495175967570385498&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-vehicle-and-fuel-emissions-laboratory-us-epa",
      "poi_latitude": "42.30364600000001",
      "poi_longitude": "-83.7110392",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 734-214-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2b5-72a9-a510-13eafa3a91df.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019d752f-a2b5-72a9-a510-13eafa3a91df",
        "storage_key": "property/6767906449167447/019d752f-a2b5-72a9-a510-13eafa3a91df.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqwtLXyisPIgRWtozD3LsCdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_506d0a080ac7786d45d61359",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "Washtenaw Community College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4800 E Huron River Dr, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-2449-7665-8e65-26d3ad530fbb.webp",
      "poi_featured_image_media": {
        "alt_text": "People walking and sitting in a park-like courtyard with a large abstract sculpture and yellow umbrellas.",
        "public_id": "019d7533-2449-7665-8e65-26d3ad530fbb",
        "storage_key": "property/6767906449167447/019d7533-2449-7665-8e65-26d3ad530fbb.webp",
        "width": 678,
        "height": 448
      },
      "poi_business_url": "https://www.wccnet.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16982238471511117744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washtenaw-community-college",
      "poi_latitude": "42.2635478",
      "poi_longitude": "-83.6655359",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 734-973-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019d752f-a2be-7538-874a-0d927479de89",
        "storage_key": "property/6767906449167447/019d752f-a2be-7538-874a-0d927479de89.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPeUUHyGpPIgRsI9kAeoHres",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_8cb362fe1129cbaf5d683f65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "poi_name": "VA Ann Arbor Healthcare System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2215 Fuller Rd, Ann Arbor, MI 48105, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d7533-f21f-7266-ac56-b1deb8afc576.webp",
      "poi_featured_image_media": {
        "alt_text": "Waiting area with rows of chairs and a reception desk.",
        "public_id": "019d7533-f21f-7266-ac56-b1deb8afc576",
        "storage_key": "property/6767906449167447/019d7533-f21f-7266-ac56-b1deb8afc576.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.annarbor.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13510119231272735885&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "va-ann-arbor-healthcare-system",
      "poi_latitude": "42.2866278",
      "poi_longitude": "-83.7141772",
      "poi_miles_from_property": "12.7 mi",
      "poi_walking_minutes": "4 hours 41 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 734-769-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
      "poi_map_icon_media": {
        "alt_text": "H logo",
        "public_id": "019d752f-a2f9-70ac-82fa-270f0ce1a669",
        "storage_key": "property/6767906449167447/019d752f-a2f9-70ac-82fa-270f0ce1a669.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-Ha4IuuPIgRjVQvddyVfbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_9faf1a7f7f21a9d164932866",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c4fe188c5c6fd7168597ad5d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_31e8c3dc88c09764745faced",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6d40d201d60bac013ba78361",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_71a45df156e2fcc1e92b2daf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_9dc5e357a9cbaafa4c83e3eb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "These are brand new!  Lots of space, lots of closet space, huge pantry and garage. Full of sunshine. ",
      "date": "false",
      "title": "Beautiful "
    },
    {
      "id": "ec_28aa6172b27397f1271cc4fe",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Representative was friendly and knowledgeable. Community was well maintained.",
      "date": "false",
      "title": "Exactly what we’re looking for"
    },
    {
      "id": "ec_b7bece5273a9e10c83e8c14f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Completed on a timely manner.",
      "date": "false",
      "title": "Ice Machine not working"
    },
    {
      "id": "ec_adf57082f48e9fb83428579e",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Good preventative maintenance",
      "date": "false",
      "title": "Maintenance"
    },
    {
      "id": "ec_ca145291621b005e4b37a00f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "We're evaluating several housing options, but even if we don't settle at Redwood, it won't be because the facilities were deficient. The manager who worked with us was very professional, showing us everything we asked about and explaining the terms clearly. The units were clean and ready to move in, the layout of the entire complex was simple and practical, and the staff we spoke to all seemed competent and friendly.",
      "date": "false",
      "title": "Beautiful facility"
    },
    {
      "id": "ec_aff63b3d0eba9b8a6a5250f8",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "maintenance returned my call right away and explain what I need to do and came to reset and give duplicate garage opener. The same thing with the Manager (April) called back even on a saturday. Courteous and prompt.",
      "date": "false",
      "title": "garage opener got stolen from my car in my driveway"
    },
    {
      "id": "ec_7328713ccc9d019e1045a8dd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Very nice community .",
      "date": "false",
      "title": "Beautiful community."
    },
    {
      "id": "ec_4c763ac31527e79eba6b7443",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "The Redwood Manager was very prompt and professional. The maintenance personnel was very effective explaining things and the redwood manager answered all of our questions. The walkthrough was well timed and things were explained on who we call what what issues or questions!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_0afdf6da13dfaaf808be93fa",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Like Home I enjoyed my stay at Redwood. The community was amazing and the maintenance team was very responsive. Ron is the best!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_6bdc4abe58f66b3c0fddcd74",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Very nice Was comfortable to be able to see the place at out pace. It’s a very nice place",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9b6eb82bb35ae4e1b2d161ea",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Great Place! Redwood Ypsilanti is a great place to live. Great community and wonderful property management.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_45004ad1583100c2a5313e8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Visit  Very thorough answered all questions.  Truly welcoming when you walk in.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_1cf2ed577244ac31e5128914",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Redwood Ypsilanti  April and her staff took great care of us when we lived here temporarily due to our fire. They made the transition easy and helped us whenever we needed something. If our insurance wasn’t going to repair our home, we could have stayed here forever!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_b5a3743045b678eedef34f91",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Beautiful Homes & friendly service.  We loved the tour. We received all the information we needed, questions answered with a friendly and knowledgeable staff.",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_34637298b1cedf000aad8b61",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Just exceptional!  We lived here for 5 years and could not be happier with our experience. The staff is so kind and friendly. Maintenance is prompt and fills requests with a lot of urgency. Truly luxury service. Thank you !!!",
      "date": "false",
      "title": "Verified Renter"
    },
    {
      "id": "ec_9dcc3f51a40a13795dc5c60b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "rating": "5",
      "name": "false",
      "text": "Wonderful place to live  During my 5.5 year stay, in the Redwood neighborhood has been great. The staff and crew were always helpful. Repairs were handled quickly with no drama. I’d rent at redwood again.",
      "date": "false",
      "title": "Verified Renter"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_0717224078588792aab5f180",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "LoopNet Video",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/0p0c2k?source=180"
    },
    {
      "id": "ec_217f6ed75b9adb50ba1dbcc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-777e-75db-adcb-4daef5b53fae.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d752f-777e-75db-adcb-4daef5b53fae",
        "storage_key": "property/6767906449167447/019d752f-777e-75db-adcb-4daef5b53fae.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "2 BR, 2 BA - Willowood, 1381 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DLNQyCdEoTp"
    }
  ],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-ypsilanti-mi",
      "search_query": "apartments with in-unit laundry Ypsilanti MI",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover modern apartments with in-unit laundry in Ypsilanti, MI. Enjoy the comfort and convenience of Redwood Ypsilanti Apartments.",
      "page_copy": "Redwood Ypsilanti Apartments offers modern living with the convenience of apartments that feature in-unit laundry in Ypsilanti, MI. Our community not only enhances your lifestyle with essential amenities but also provides unique features like sliding glass doors that open to personal patios, creating a relaxing environment to unwind after laundry day. \n\nExperience apartment living at its finest with en-suite bathrooms and large closets in the main bedroom, designed for practicality and luxury. Located in Washtenaw County, take advantage of the den for work or leisure activities and participate in vibrant resident events throughout the year. We welcome up to three pets per home, making this the perfect place for every member of your family. Discover more about living with ease and convenience at Redwood Ypsilanti Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ypsilanti MI Apartments In-Unit Laundry",
      "seo_description": "Explore Redwood Ypsilanti Apartments with in-unit laundry, featuring patios, resident events, and pet-friendly options in Ypsilanti, MI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-washtenaw-county",
      "search_query": "pet friendly apartments Washtenaw County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Washtenaw County",
      "h2_subtitle": "Find perfect pet-friendly apartments in Washtenaw County. Redwood Ypsilanti Apartments welcomes up to three pets per home.",
      "page_copy": "Nestled in the heart of Washtenaw County, Redwood Ypsilanti Apartments is your ideal choice for pet-friendly living. Our welcoming community allows up to three pets per home, ensuring every member of your family has a place. Enjoy modern amenities, like sliding glass doors leading to private patios, providing ample space for relaxation and play.\n\nOur apartments feature en-suite bathrooms and large closets in the main bedroom, perfect for a comfortable lifestyle. Located in vibrant Ypsilanti, partake in various resident events that foster community engagement and fun. With the added convenience of a den, you have the option to create a personalized workspace or leisure area. Join us and experience a harmonious blend of comfort and convenience in a pet-friendly environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Washtenaw County",
      "seo_description": "Redwood Ypsilanti Apartments in Washtenaw County welcomes up to three pets per home. Enjoy patios, resident events, and more!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-ypsilanti",
      "search_query": "apartments with air conditioning Ypsilanti",
      "category": "Amenity",
      "h1_title": "Ypsilanti Apartments with Air Conditioning",
      "h2_subtitle": "Enjoy comfortable living with air-conditioned apartments in Ypsilanti. Redwood Ypsilanti Apartments offer climate control for a pleasant home environment.",
      "page_copy": "At Redwood Ypsilanti Apartments, experience the comfort of apartments with air conditioning in Ypsilanti. Our well-appointed homes are designed to keep you cool and comfortable, regardless of the weather outside. Each apartment features sliding glass doors that open to personal patios, perfect for enjoying fresh air and outdoor relaxation.\n\nOur spacious residences come with en-suite bathrooms and large closets in the main bedroom, providing a blend of privacy and storage. Located in the lively Ypsilanti area, our community hosts regular resident events, enhancing the sense of camaraderie and community spirit. We also feature a den that can be transformed into a cozy retreat or an efficient workspace. Live comfortably and conveniently with the added benefit of a pet-friendly policy that welcomes up to three pets per home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ypsilanti Apartments Air Conditioning",
      "seo_description": "Discover air-conditioned living at Redwood Ypsilanti Apartments. Enjoy patios, events, and pet-friendly homes in Ypsilanti, MI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "ypsilanti-apartments-attached-garage",
      "search_query": "Ypsilanti apartments with attached garage",
      "category": "Amenity",
      "h1_title": "Ypsilanti Apartments with Attached Garage",
      "h2_subtitle": "Explore apartments in Ypsilanti with attached garages. Discover the convenient living at Redwood Ypsilanti Apartments today.",
      "page_copy": "Redwood Ypsilanti Apartments offers you the convenience of living in Ypsilanti apartments with attached garages. Our unique community provides easy parking and secure storage in your attached garage, adding an extra layer of convenience to your daily life. Apart from this feature, our apartments boast sliding glass doors leading to personal patios, perfect for relaxation and entertaining guests.\n\nEach home is thoughtfully designed with en-suite bathrooms and large closets in the main bedroom, ensuring a comfortable living experience. The vibrant neighborhood is complemented by frequent resident events, promoting a strong community atmosphere. Additionally, our den offers a versatile space ideal for work or leisure activities. Enjoy pet-friendly living with up to three pets welcome per home, making Redwood Ypsilanti Apartments a perfect fit for those seeking practicality and warmth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ypsilanti Apartments with Attached Garage",
      "seo_description": "Find attached garage convenience at Redwood Ypsilanti Apartments. Enjoy patios, dens, and pet-friendly living in Ypsilanti, MI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-near-48197",
      "search_query": "dog friendly apartments near 48197",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments Near 48197",
      "h2_subtitle": "Discover dog-friendly apartments near 48197. Redwood Ypsilanti Apartments offers a welcoming environment for pets and their owners.",
      "page_copy": "Welcome to Redwood Ypsilanti Apartments, convientely located near the 48197 area, where dog-friendly apartments make pet ownership easy. Our community warmly welcomes up to three pets per home, making it perfect for you and your furry friends. Each apartment features sliding glass doors that lead to private patios—ideal spots for spending quality time with your pets outdoors.\n\nLife here is convenient and comfortable, with amenities like en-suite bathrooms and generous closet spaces in the main bedroom. Our vibrant community fosters connections through regular resident events, making it easy to meet fellow pet lovers. Enjoy additional functionality with a versatile den space, useful as an office or relaxation zone. Join our warm and welcoming environment, where your pets are not only accepted but celebrated.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments Near 48197",
      "seo_description": "Redwood Ypsilanti Apartments near 48197 are dog-friendly. Enjoy patios, den space, and up to three pets in Ypsilanti, MI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-ypsilanti-mi",
      "search_query": "two bedroom apartments ypsilanti mi",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Ypsilanti, MI",
      "h2_subtitle": "Explore our two-bedroom apartments in Ypsilanti, MI. Redwood Ypsilanti Apartments offers spacious living and modern comforts.",
      "page_copy": "Discover the spacious and modern two-bedroom apartments in Ypsilanti, MI, at Redwood Ypsilanti Apartments. Our homes are thoughtfully designed to provide ample space and flexibility for a variety of living arrangements. Each apartment comes with sliding glass doors that open to personal patios, perfect for enjoying the outdoors or entertaining guests.\n\nThe primary bedroom features an en-suite bathroom and a large closet, ensuring privacy and convenience. The open layout is enhanced by a versatile den, which can be used as a home office or cozy retreat. Located in the lively Ypsilanti neighborhood, our community is pet-friendly, allowing up to three pets per residence. Participate in frequent resident events that foster community spirit and connection among neighbors. Experience superior living and enjoy every aspect of home life at Redwood Ypsilanti Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments Ypsilanti, MI",
      "seo_description": "Find spacious two-bedroom apartments at Redwood Ypsilanti Apartments, MI. Enjoy patios, dens, and pet-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-near-eastern-michigan-university-ypsilanti",
      "search_query": "apartments near eastern michigan university ypsilanti",
      "category": "School",
      "h1_title": "Apartments Near Eastern Michigan University",
      "h2_subtitle": "Find the perfect apartment near Eastern Michigan University. Redwood Ypsilanti Apartments offers convenience and comfort close to campus.",
      "page_copy": "If you're searching for apartments near Eastern Michigan University in Ypsilanti, look no further than Redwood Ypsilanti Apartments. Perfectly located for students, faculty, and staff, our community offers both convenience and a welcoming atmosphere. Each spacious apartment features sliding glass doors that lead to private patios, enhancing your living experience.\n\nOur residents enjoy en-suite bathrooms and large closets in the main bedrooms, ensuring comfort and functionality. With a versatile den in each apartment, you have the option to create a home office or personal study area. As a pet-friendly community, we accommodate up to three pets per residence, making it easy to bring your furry friends along. Join us at Redwood Ypsilanti where you'll find a vibrant atmosphere, complemented by resident events and close proximity to Eastern Michigan University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Eastern Michigan University",
      "seo_description": "Redwood Ypsilanti Apartments offer comfort near Eastern Michigan University. Enjoy patios, dens, and pet-friendly homes in Ypsilanti, MI.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-close-to-pray-harrold-washtenaw-county",
      "search_query": "apartments close to pray-harrold washtenaw county",
      "category": "School",
      "h1_title": "Apartments Close to Pray-Harrold, Washtenaw County",
      "h2_subtitle": "Discover apartments close to Pray-Harrold in Washtenaw County. Redwood Ypsilanti Apartments offers easy access and modern amenities.",
      "page_copy": "Located conveniently close to Pray-Harrold in Washtenaw County, Redwood Ypsilanti Apartments offer an ideal living solution. Our community provides residents with easy access to key educational institutions, making daily commutes a breeze. Each apartment features generous living spaces and sliding glass doors that lead to private patios, perfect for relaxing after a long day.\n\nOur homes include main bedrooms with en-suite bathrooms and large closets, ensuring every convenience is at your fingertips. The versatile den provides an additional space that can be transformed into a study or hobby room. With pet-friendly policies allowing up to three pets, your furry friends will feel right at home. Experience a community with vibrant resident events, designed to foster connections and create a welcoming atmosphere at Redwood Ypsilanti Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Pray-Harrold, Washtenaw County",
      "seo_description": "Live near Pray-Harrold in Washtenaw County at Redwood Ypsilanti Apartments. Enjoy patio access, spacious rooms, and pet-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-by-mark-jefferson-science-complex-mi",
      "search_query": "apartments by mark jefferson science complex mi",
      "category": "School",
      "h1_title": "Apartments by Mark Jefferson Science Complex",
      "h2_subtitle": "Find ideal apartments by the Mark Jefferson Science Complex, MI. Experience convenience and style at Redwood Ypsilanti Apartments.",
      "page_copy": "Redwood Ypsilanti Apartments are perfectly situated near the Mark Jefferson Science Complex in MI, providing an excellent choice for those seeking proximity and convenience. Our community offers spacious apartments with features like sliding glass doors that open onto personal patios, providing a seamless blend of indoor and outdoor living.\n\nEach apartment is designed with a main bedroom featuring an en-suite bathroom and a large closet, ensuring privacy and plenty of storage. Additionally, the presence of a den allows for customization as an office or relaxation space. Our pet-friendly policies allow residents to keep up to three pets, offering a warm welcome to all family members. Redwood Ypsilanti Apartments also hosts resident events, enhancing the sense of community and engagement. Choose us for your living solution near the Mark Jefferson Science Complex.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Mark Jefferson Science Complex, MI",
      "seo_description": "Choose Redwood Ypsilanti Apartments near the Mark Jefferson Science Complex. Experience patios, versatile dens, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-near-trinity-health-ann-arbor-hospital-ypsilanti",
      "search_query": "apartments near Trinity Health Ann Arbor Hospital Ypsilanti",
      "category": "Hospital",
      "h1_title": "Apartments Near Trinity Health Ann Arbor Hospital",
      "h2_subtitle": "Explore apartments near Trinity Health Ann Arbor Hospital. Enjoy comfort and convenience at Redwood Ypsilanti Apartments.",
      "page_copy": "Redwood Ypsilanti Apartments offers an ideal location for those seeking apartments near Trinity Health Ann Arbor Hospital in Ypsilanti. Our community is perfect for healthcare professionals and patients alike, providing a quick and convenient commute. Enjoy spacious living with sliding glass doors that lead to private patios, allowing you to unwind and enjoy the fresh air.\n\nEach apartment includes a main bedroom with an en-suite bathroom and a generous closet, ensuring all the comforts of home. The additional den offers versatile space, perfect as an office or personal retreat. We welcome up to three pets per home, accommodating your entire family, furry friends included. Join our community to experience lively resident events and a neighborly atmosphere, all while being close to Trinity Health Ann Arbor Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trinity Health Ann Arbor Hospital",
      "seo_description": "Redwood Ypsilanti Apartments offer convenient living near Trinity Health Ann Arbor Hospital. Enjoy patios, spacious interiors, and pet-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-close-to-trinity-health-reichert-medical-center-washtenaw-county",
      "search_query": "apartments close to Trinity Health Reichert Medical Center Washtenaw County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Trinity Health Reichert Center",
      "h2_subtitle": "Discover apartments close to Trinity Health Reichert Medical Center in Washtenaw County at Redwood Ypsilanti Apartments.",
      "page_copy": "Situated near the Trinity Health Reichert Medical Center in Washtenaw County, Redwood Ypsilanti Apartments offer exceptional convenience for medical professionals and patients. Our community is designed for comfort, featuring residences with sliding glass doors that lead to private patios, making it easy to enjoy the outdoors.\n\nEach apartment is equipped with a main bedroom that includes an en-suite bathroom and a roomy closet, providing ease and ample storage. A versatile den offers additional space for a home office or recreation area. With pet-friendly policies allowing up to three pets, our apartments welcome your entire family. Residents can also participate in engaging events throughout the year, enhancing community spirit at Redwood Ypsilanti Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Trinity Health Reichert Medical Center",
      "seo_description": "Live near Trinity Health Reichert Medical Center in Washtenaw County at Redwood Ypsilanti Apartments. Enjoy modern living with patios and pet-friendly options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167447",
      "source": "generator",
      "page_item_url": "apartments-near-rolling-hills-park-ypsilanti-mi",
      "search_query": "apartments near rolling hills park ypsilanti mi",
      "category": "Park",
      "h1_title": "Apartments Near Rolling Hills Park, Ypsilanti",
      "h2_subtitle": "Find serene apartments near Rolling Hills Park in Ypsilanti, MI. Experience the comfort of Redwood Ypsilanti Apartments.",
      "page_copy": "For nature lovers seeking an excellent location, Redwood Ypsilanti Apartments offer homes near the scenic Rolling Hills Park in Ypsilanti, MI. Enjoy easy access to outdoor recreation while residing in spacious, comfortable apartments featuring sliding glass doors to personal patios—a perfect spot for relaxing outdoors.\n\nOur apartments are thoughtfully designed with a main bedroom that has an en-suite bathroom and a large closet. Whether you need a quiet place for work or play, the den provides a versatile area just for that. Being pet-friendly, we welcome up to three pets, ensuring that your furry companions feel at home. Throughout the year, residents have the chance to engage in various community events, making Redwood Ypsilanti Apartments a truly inviting place to live near Rolling Hills Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of townhomes with garages and manicured lawns.",
        "public_id": "019d752f-6e45-73fa-b5d3-7d427ed8d2fb",
        "storage_key": "property/6767906449167447/019d752f-6e45-73fa-b5d3-7d427ed8d2fb.webp",
        "width": 2880,
        "height": 2160
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rolling Hills Park, Ypsilanti, MI",
      "seo_description": "Discover Redwood Ypsilanti Apartments near Rolling Hills Park in Ypsilanti, MI. Enjoy patios, spacious living areas, and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": []
};

export const generatedAt = '2026-10-05T19:01:15.279Z';
